<template>
  <div>
    <body
      class="site-nexusmods-b scheme-theme-ReskinOrange game-theme-0 logged-out apage nexushome new-head"
    >
      <header id="head" class="new-head">
        <div class="rj-header-wrap">
          <a class="skip-to-content" href="#mainContent">Skip to content</a>
          <a class="headlogo" href="/" :alt="proName" :title="proName">
            <!-- <div>
              <img :src="topLogo" />
            </div> -->
          </a>
          <div class="rj-nav nav-alignment">
            <button
              class="nav-tab-button"
              v-for="item in meunList"
              :key="item"
              :data-title="item.name"
            >
              {{ item.name }}
            </button>
          </div>

          <form class="rj-search" method="POST" action="/">
            <input
              id="gsearch"
              class="rj-search-input"
              name="gsearch"
              data-url="/"
              type="text"
              placeholder="Search"
              autocomplete="off"
              aria-label="Search"
            />
            <input
              id="searchtype"
              type="hidden"
              name="gsearchtype"
              value="mods"
            />
            <!--                <i class="material-icons">search</i>-->
            <div class="rj-search-category-wrapper">
              <button type="button" class="rj-search-category-dropdown-toggle">
                <div class="rj-search-category">
                  <span class="rj-search-category-name">Mods</span>
                </div>
              </button>
              <ul class="rj-search-category-dropdown">
                <li
                  class="rj-search-category-option category-selected"
                  data-category-value="mods"
                >
                  Mods
                </li>
                <li
                  class="rj-search-category-option"
                  data-category-value="games"
                >
                  Games
                </li>
                <li
                  class="rj-search-category-option"
                  data-category-value="images"
                >
                  Images
                </li>
                <li
                  class="rj-search-category-option"
                  data-category-value="videos"
                >
                  Videos
                </li>
                <li
                  class="rj-search-category-option"
                  data-category-value="authors"
                >
                  Users
                </li>
              </ul>
            </div>
            <div
              id="gsearch_results"
              class="hidden"
              style="display: none"
              tabindex="0"
            ></div>
            <button type="button" class="rj-search-button">
              <i class="material-icons">search</i>
            </button>
          </form>

          <div class="rj-login-nav">
            <a
              id="login"
              class="rj-btn rj-btn-clear"
              href="/"
              :title="`Log in to ${proName}`"
              tabindex="0"
              >Log in</a
            >
            <a class="rj-btn rj-btn-standard" href="/">Register</a>
          </div>
        </div>
      </header>

      <div class="wrapper" id="mainContent">
        <div id="nn_skinl"></div>
        <div id="nn_skinr"></div>
        <div class="clearfix" style="text-align: center; background: #2d2d2d">
          <div class="ads">
            <amp-ad
              width="100vw"
              height="320"
              type="adsense"
              :data-ad-client="clientId"
              :data-ad-slot="clientslotId"
              data-auto-format="rspv"
              data-full-width=""
            >
              <div overflow=""></div>
            </amp-ad>
            <div id="ad-container" align="center"></div>
          </div>
        </div>
        <section class="static homeindex">
          <div class="home-intro">
            <div class="intro">
              <h1>
                Welcome to <span>{{ proName }}</span>
              </h1>
              <!-- <p id="opening">
                We host <span id="total_mods">668,218</span> mods for
                <a id="total_games" href="/games/">3,496 games</a> from
                <span id="total_authors">151,500</span> authors serving
                <span id="total_users">59,666,083</span> members with
                <span id="total_network_downloads">14,941,527,508</span>
                downloads to date. We've donated
                <a href="/about/donation-points" class="total-dp">$2,224,356</a>
                to our mod authors through Donation Points. If you can mod it,
                we'll host it.
              </p> -->
              <!-- <div class="home-buttons">
                <a href="https://www.nexusmods.com/mods/" class="btn"
                  >Browse all files</a
                >
              </div> -->
            </div>

            <div style="margin-top: 20px" class="rj-gameslist-home">
              <div id="games-list">
                <div class="game-filter flex clearfix" style="display: none">
                  <form lpformnum="1" id="our-games-filter">
                    <ul class="sorting clearfix">
                      <li class="filter-name flex-stretch">
                        <label class="navlabel" for="f_name"
                          >Filter by name</label
                        >
                        <input
                          type="text"
                          id="f_name"
                          name="f_name"
                          value=""
                          placeholder="Enter name..."
                        />
                      </li>
                      <li class="sort-by">
                        <div class="navlabel">Sort by</div>
                        <select
                          id="sort_by"
                          name="sort_by"
                          class="select-custom select2-hidden-accessible"
                          tabindex="-1"
                          aria-hidden="true"
                        >
                          <option value="mods">Mod count</option>
                          <option value="name">Name</option>
                          <option value="approved_date">Date added</option>
                          <option value="downloads" selected>
                            Download count
                          </option>
                        </select>
                      </li>
                      <li class="sort-order">
                        <div class="navlabel">Order</div>
                        <select
                          id="order"
                          name="order"
                          class="select-custom"
                          tabindex="-1"
                          aria-hidden="true"
                        >
                          <option value="asc">Asc</option>
                          <option value="desc" selected="selected">Desc</option>
                        </select>
                      </li>
                    </ul>
                  </form>
                </div>

                <div class="game-section">
                  <ul class="tiles game-tiles">
                    <li
                      class="image-tile fill-game-downloads"
                      id="game-tile-1704"
                      data-game-id="1704"
                      v-for="item in gameList"
                      :key="item"
                      @click="navigateToGame(item.aHerf)"
                    >
                      <a name="game-tile-1704"></a>
                      <div class="mod-tile-left">
                        <!-- DROPDOWN -->
                        <div class="expandtile image-tile-bg"></div>
                        <!-- end of DROPDOWN -->
                        <a class="mod-image" href="/play">
                          <img
                            class="lazy game_cover"
                            loading="lazy"
                            :src="item.gameImageUrl"
                            width="400"
                            height="225"
                            alt="Skyrim Special Edition"
                            title="Skyrim Special Edition (104546) "
                          />

                          <div class="tile-desc image-tile-bg">
                            <p class="tile-name">{{ item.gameName }}</p>
                            <div class="tile-data">
                              <ul class="clearfix">
                                <!-- <li class="filecount inline-flex">
                                  <svg class="icon icon-files">
                                    <use
                                      xlink:href="/assets/images/icons/icons.svg#icon-files"
                                    ></use>
                                  </svg>
                                  <span class="flex-label">104.5k</span>
                                </li>
                                <li class="downloadcount inline-flex">
                                  <svg class="icon icon-downloads">
                                    <use
                                      xlink:href="/assets/images/icons/icons.svg#icon-downloads"
                                    ></use>
                                  </svg>
                                  <span
                                    class="flex-label fill-game-download-count"
                                  >
                                    {{ item.score }}
                                  </span>
                                </li> -->
                              </ul>
                            </div>
                          </div>
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- <div class="btn-more">
              <a href="/games/" class="btn" id="view_total_games"
                >View all 3,496 games</a
              >
            </div> -->
          </div>

          <div class="collections-banner-outer-wrapper-trigger">
            <div class="collections-banner-wrapper">
              <a class="collections-banner" href="/">
                <div class="collections-banner__splash">
                  <img
                    class="collections-banner__splash-image"
                    src="https://www.nexusmods.com/assets/images/collections-banner-splash.png"
                    role="presentation"
                    alt=""
                  />
                </div>
                <i class="user-profile-menu-icon-collections"></i>
                <span
                  >Download <strong>19,685 Collections</strong> for
                  <strong>176 games</strong></span
                >
                <i class="material-icons">chevron_right</i>
              </a>
            </div>
          </div>
          <section class="premium-block premium-block--register background-1">
            <div class="premium-block__text-wrapper">
              <h2>Join Us</h2>
            </div>
            <div class="premium-block__link-wrapper">
              <a class="rj-btn rj-btn-standard" href="/"
                ><span>Register</span></a
              >
              <span>Already have an account? <a href="/">Log in here</a></span>
            </div>
          </section>

          <div class="wrap tab-block clearfix">
            <div class="col-1-1">
              <div class="tab-head clearfix">
                <h2>All of our games</h2>
              </div>
              <div class="tabs">
                <!-- <ul class="modtabs">
                  <li title="All news">
                    <a
                      class="selected"
                      href="/?_route=home&_controller=NexusMods%5CController%5CHomeController%3A%3Aindex&tab=all+news"
                      data-target="/Core/Libs/Common/Widgets/NewsTabContent?page_size=12&nav=0&category_id=0&home_page=1"
                    >
                      <span class="tab-label">All news</span>
                    </a>
                  </li>
                  <li title="Features">
                    <a
                      href="/?_route=home&_controller=NexusMods%5CController%5CHomeController%3A%3Aindex&tab=features"
                      data-target="/Core/Libs/Common/Widgets/NewsTabContent?page_size=12&nav=0&category_id=110&home_page=1"
                    >
                      <span class="tab-label">Features</span>
                    </a>
                  </li>
                  <li title="Site news">
                    <a
                      href="/?_route=home&_controller=NexusMods%5CController%5CHomeController%3A%3Aindex&tab=site+news"
                      data-target="/Core/Libs/Common/Widgets/NewsTabContent?page_size=12&nav=0&category_id=100&home_page=1"
                    >
                      <span class="tab-label">Site news</span>
                    </a>
                  </li>
                  <li title="Competition news">
                    <a
                      href="/?_route=home&_controller=NexusMods%5CController%5CHomeController%3A%3Aindex&tab=competition+news"
                      data-target="/Core/Libs/Common/Widgets/NewsTabContent?page_size=12&nav=0&category_id=111&home_page=1"
                    >
                      <span class="tab-label">Competition news</span>
                    </a>
                  </li>
                  <li title="Game news">
                    <a
                      href="/?_route=home&_controller=NexusMods%5CController%5CHomeController%3A%3Aindex&tab=game+news"
                      data-target="/Core/Libs/Common/Widgets/NewsTabContent?page_size=12&nav=0&category_id=103&home_page=1"
                    >
                      <span class="tab-label">Game news</span>
                    </a>
                  </li>
                  <li title="Mod news">
                    <a
                      href="/?_route=home&_controller=NexusMods%5CController%5CHomeController%3A%3Aindex&tab=mod+news"
                      data-target="/Core/Libs/Common/Widgets/NewsTabContent?page_size=12&nav=0&category_id=101&home_page=1"
                    >
                      <span class="tab-label">Mod news</span>
                    </a>
                  </li>
                  <li title="Interviews">
                    <a
                      href="/?_route=home&_controller=NexusMods%5CController%5CHomeController%3A%3Aindex&tab=interviews"
                      data-target="/Core/Libs/Common/Widgets/NewsTabContent?page_size=12&nav=0&category_id=105&home_page=1"
                    >
                      <span class="tab-label">Interviews</span>
                    </a>
                  </li>
                  <li title="Articles by mod authors">
                    <a
                      href="/?_route=home&_controller=NexusMods%5CController%5CHomeController%3A%3Aindex&tab=mod+updates"
                      data-target="/Core/Libs/Common/Widgets/ModArticlesTab?page=1&nav=0"
                    >
                      <span class="tab-label">Mod updates</span>
                    </a>
                  </li>
                </ul> -->
                <div class="mobile-tabs">
                  <div class="navlabel">Current section</div>
                  <ul class="tabs-clone">
                    <li>
                      <a class="clearfix">
                        <strong>Viewing:</strong>
                        <span class="tab-view"></span>
                        <svg title="" class="icon-arrow">
                          <use
                            xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-arrow"
                          ></use>
                        </svg>
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="tabcontent">
                  <div id="news-container">
                    <div class="container" id="news-content">
                      <ul class="tiles">
                        <li
                          class="article-tile"
                          v-for="item in gameBottomList"
                          :key="item"
                          @click="navigateToGame(item.aHerf)"
                        >
                          <div class="mod-tile-left">
                            <div class="clearfix single-image">
                              <div class="fadeoff image_fade"></div>
                              <!-- <a class="mod-image" href="/"> -->
                              <img
                                loading="lazy"
                                :src="item.gameImageUrl"
                                alt=""
                              />
                              <!-- </a> -->
                            </div>
                            <div class="tile-desc">
                              <div class="fadeoff"></div>
                              <div class="tile-content">
                                <p class="tile-name">
                                  <a href="/">{{ item.gameName }}</a>
                                </p>
                              </div>
                            </div>
                            <!-- <div class="tile-data">
                              <ul class="clearfix">
                                <li class="inline-flex">
                                  <svg title="" class="icon icon-comment">
                                    <use
                                      xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-comment"
                                    ></use>
                                  </svg>
                                  <span
                                    class="flex-label comment-count"
                                    data-comment-count="15"
                                    >15 Comments</span
                                  >
                                </li>
                              </ul>
                            </div> -->
                          </div>
                        </li>
                      </ul>
                    </div>

                    <!-- <div class="btn-more">
                      <a
                        href="https://www.nexusmods.com/news/?category_id=0&page=2"
                        class="btn"
                        >View more games</a
                      >
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="wrap tab-block clearfix">
            <div class="col-1-1">
              <div class="tab-head clearfix">
                <h2>All of our mods</h2>
                <a href="/mods/" class="view-all">Explore all mods</a>
              </div>
              <div class="tabs">
                <ul class="modtabs">
                  <li title="Mods uploaded today">
                    <a
                      class="selected"
                      href="/?_route=home&_controller=NexusMods%5CController%5CHomeController%3A%3Aindex&tab=new+today"
                      data-target="/mods/today/?nav=0&page_size=20"
                    >
                      <span class="tab-label">New today</span>
                      <span class="alert">493</span>
                    </a>
                  </li>
                  <li title="Mods uploaded this week">
                    <a
                      href="/?_route=home&_controller=NexusMods%5CController%5CHomeController%3A%3Aindex&tab=new+this+week"
                      data-target="/mods/thisweek/?nav=0&page_size=20"
                    >
                      <span class="tab-label">New this week</span>
                      <span class="alert">3,553</span>
                    </a>
                  </li>
                  <li title="Most downloaded mods in the last 30 days">
                    <a
                      href="/?_route=home&_controller=NexusMods%5CController%5CHomeController%3A%3Aindex&tab=popular+%2830+days%29"
                      data-target="/mods/popular/?nav=0&page_size=20"
                    >
                      <span class="tab-label">Popular (30 days)</span>
                    </a>
                  </li>
                  <li title="Most downloaded mods">
                    <a
                      href="/?_route=home&_controller=NexusMods%5CController%5CHomeController%3A%3Aindex&tab=popular+%28all+time%29"
                      data-target="/mods/popularalltime/?nav=0&page_size=20"
                    >
                      <span class="tab-label">Popular (all time)</span>
                    </a>
                  </li>
                  <li
                    title="Mods that have the highest number of endorsements in the last 7 days"
                  >
                    <a
                      href="/?_route=home&_controller=NexusMods%5CController%5CHomeController%3A%3Aindex&tab=trending"
                      data-target="/mods/trending/?nav=0&page_size=20"
                    >
                      <span class="tab-label">Trending</span>
                    </a>
                  </li>
                  <li title="Random mods">
                    <a
                      href="/?_route=home&_controller=NexusMods%5CController%5CHomeController%3A%3Aindex&tab=random"
                      data-target="/mods/random/?nav=0&page_size=20"
                    >
                      <span class="tab-label">Random</span>
                    </a>
                  </li>
                  <li title="Mods updated recently">
                    <a
                      href="/?_route=home&_controller=NexusMods%5CController%5CHomeController%3A%3Aindex&tab=updated"
                      data-target="/mods/updated/?nav=0&page_size=20"
                    >
                      <span class="tab-label">Updated</span>
                    </a>
                  </li>
                </ul>
                <div class="mobile-tabs">
                  <div class="navlabel">Current section</div>
                  <ul class="tabs-clone">
                    <li>
                      <a class="clearfix">
                        <strong>Viewing:</strong>
                        <span class="tab-view"></span>
                        <svg title="" class="icon-arrow">
                          <use
                            xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-arrow"
                          ></use>
                        </svg>
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="tabcontent">
                  <div id="mod-list" class="container">
                    <ul class="tiles">
                      <li class="mod-tile">
                        <div id="mod-tile-gallery-1704-142447"></div>

                        <div
                          data-mod-id="142447"
                          data-game-id="1704"
                          class="mod-tile-left"
                        >
                          <div class="expandtile">
                            <div class="btnexpand btnoverlay inline-flex">
                              <div class="padding"></div>
                              <svg title="" class="icon-plus">
                                <use
                                  xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-plus"
                                ></use>
                              </svg>
                              <ul>
                                <li>
                                  <a
                                    class="mod-view"
                                    href="https://www.nexusmods.com/skyrimspecialedition/mods/142447"
                                  >
                                    View mod page
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="mod-gallery"
                                    href="https://www.nexusmods.com/skyrimspecialedition/mods/142447?tab=images"
                                    onclick="get_mod_images(1704,142447, 74877883, )"
                                  >
                                    View image gallery
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <a
                            class="mod-image"
                            href="https://www.nexusmods.com/skyrimspecialedition/mods/142447"
                          >
                            <figure class="image_figure">
                              <img
                                class="back"
                                src="https://www.nexusmods.com/assets/images/default/noimage.svg"
                                width="600"
                                height="338"
                                alt=""
                              />
                              <div class="fore_div_mods">
                                <img
                                  class="fore"
                                  onerror="imgError(this,'https://www.nexusmods.com/assets/images/default/noimage.svg')"
                                  loading="lazy"
                                  src="https://staticdelivery.nexusmods.com/mods/1704/images/thumbnails/142447/142447-1740134842-132845500.jpeg"
                                  alt="Peachy standalone erin followers (Korean translation)"
                                  title="Peachy standalone erin followers (Korean translation)"
                                />
                              </div>
                            </figure>
                          </a>

                          <div class="tile-desc motm-tile">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/skyrimspecialedition/mods/142447"
                                  >Peachy standalone erin followers (Korean
                                  translation)</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/skyrimspecialedition"
                                    >Skyrim Special Edition</a
                                  >
                                  &raquo;
                                  <a
                                    href="https://www.nexusmods.com/skyrimspecialedition/mods/categories/96/"
                                    >Followers & Companions</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 10:44">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="realauthor">
                                  <span class="label">Author: </span>
                                  MikhailKoizumi
                                </div>
                                <div class="author">
                                  <span class="label">Uploader: </span>
                                  <a
                                    href="https://www.nexusmods.com/users/74877883"
                                    >MikhailKoizumi</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                Peachy standalone erin followers 모드의 한국어
                                번역본입니다.
                              </p>
                            </div>
                          </div>

                          <div class="tile-data">
                            <ul class="clearfix">
                              <li class="sizecount inline-flex">
                                <svg title="" class="icon icon-filesize">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-filesize"
                                  ></use>
                                </svg>
                                <span class="flex-label"> 12KB </span>
                              </li>
                              <li class="endorsecount inline-flex">
                                <svg title="" class="icon icon-endorse">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-endorse"
                                  ></use>
                                </svg>
                                <span class="flex-label">0</span>
                              </li>
                              <li class="downloadcount inline-flex">
                                <svg title="" class="icon icon-downloads">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-downloads"
                                  ></use>
                                </svg>
                                <span class="flex-label"> -- </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="mod-tile-right">
                          <div class="tile-desc">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/skyrimspecialedition/mods/142447"
                                  >Peachy standalone erin followers (Korean
                                  translation)</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/skyrimspecialedition/mods/categories/96/"
                                    >Followers & Companions</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 10:44">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="author">
                                  <span class="label">Author: </span
                                  ><a
                                    href="https://www.nexusmods.com/users/74877883"
                                    >MikhailKoizumi</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                Peachy standalone erin followers 모드의 한국어
                                번역본입니다.
                              </p>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="mod-tile">
                        <div id="mod-tile-gallery-7286-809"></div>

                        <div
                          data-mod-id="809"
                          data-game-id="7286"
                          class="mod-tile-left"
                        >
                          <div class="expandtile">
                            <div class="btnexpand btnoverlay inline-flex">
                              <div class="padding"></div>
                              <svg title="" class="icon-plus">
                                <use
                                  xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-plus"
                                ></use>
                              </svg>
                              <ul>
                                <li>
                                  <a
                                    class="mod-view"
                                    href="https://www.nexusmods.com/kingdomcomedeliverance2/mods/809"
                                  >
                                    View mod page
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="mod-gallery"
                                    href="https://www.nexusmods.com/kingdomcomedeliverance2/mods/809?tab=images"
                                    onclick="get_mod_images(7286,809, 47514503, )"
                                  >
                                    View image gallery
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <a
                            class="mod-image"
                            href="https://www.nexusmods.com/kingdomcomedeliverance2/mods/809"
                          >
                            <figure class="image_figure">
                              <img
                                class="back"
                                src="https://www.nexusmods.com/assets/images/default/noimage.svg"
                                width="600"
                                height="338"
                                alt=""
                              />
                              <div class="fore_div_mods">
                                <img
                                  class="fore"
                                  onerror="imgError(this,'https://www.nexusmods.com/assets/images/default/noimage.svg')"
                                  loading="lazy"
                                  src="https://staticdelivery.nexusmods.com/mods/7286/images/thumbnails/809/809-1740118259-1878156289.jpeg"
                                  alt="Godwin and Henry swap (no clipping)"
                                  title="Godwin and Henry swap (no clipping)"
                                />
                              </div>
                            </figure>
                          </a>

                          <div class="tile-desc motm-tile">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/kingdomcomedeliverance2/mods/809"
                                  >Godwin and Henry swap (no clipping)</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/kingdomcomedeliverance2"
                                    >Kingdom Come: Deliverance II</a
                                  >
                                  &raquo;
                                  <a
                                    href="https://www.nexusmods.com/kingdomcomedeliverance2/mods/categories/13/"
                                    >Character</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 10:44">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="realauthor">
                                  <span class="label">Author: </span>
                                  MuhammadRizky17
                                </div>
                                <div class="author">
                                  <span class="label">Uploader: </span>
                                  <a
                                    href="https://www.nexusmods.com/users/47514503"
                                    >MuhammadRizky17</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                O Merciful God, be kind and protect us, so we
                                don't BLOW OUR ARSES OFF!
                              </p>
                            </div>
                          </div>

                          <div class="tile-data">
                            <ul class="clearfix">
                              <li class="sizecount inline-flex">
                                <svg title="" class="icon icon-filesize">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-filesize"
                                  ></use>
                                </svg>
                                <span class="flex-label"> 2KB </span>
                              </li>
                              <li class="endorsecount inline-flex">
                                <svg title="" class="icon icon-endorse">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-endorse"
                                  ></use>
                                </svg>
                                <span class="flex-label">0</span>
                              </li>
                              <li class="downloadcount inline-flex">
                                <svg title="" class="icon icon-downloads">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-downloads"
                                  ></use>
                                </svg>
                                <span class="flex-label"> -- </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="mod-tile-right">
                          <div class="tile-desc">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/kingdomcomedeliverance2/mods/809"
                                  >Godwin and Henry swap (no clipping)</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/kingdomcomedeliverance2/mods/categories/13/"
                                    >Character</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 10:44">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="author">
                                  <span class="label">Author: </span
                                  ><a
                                    href="https://www.nexusmods.com/users/47514503"
                                    >MuhammadRizky17</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                O Merciful God, be kind and protect us, so we
                                don't BLOW OUR ARSES OFF!
                              </p>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="mod-tile">
                        <div id="mod-tile-gallery-6119-2953"></div>

                        <div
                          data-mod-id="2953"
                          data-game-id="6119"
                          class="mod-tile-left"
                        >
                          <div class="expandtile">
                            <div class="btnexpand btnoverlay inline-flex">
                              <div class="padding"></div>
                              <svg title="" class="icon-plus">
                                <use
                                  xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-plus"
                                ></use>
                              </svg>
                              <ul>
                                <li>
                                  <a
                                    class="mod-view"
                                    href="https://www.nexusmods.com/helldivers2/mods/2953"
                                  >
                                    View mod page
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="mod-gallery"
                                    href="https://www.nexusmods.com/helldivers2/mods/2953?tab=images"
                                    onclick="get_mod_images(6119,2953, 157033883, )"
                                  >
                                    View image gallery
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <a
                            class="mod-image"
                            href="https://www.nexusmods.com/helldivers2/mods/2953"
                          >
                            <figure class="image_figure">
                              <img
                                class="back"
                                src="https://www.nexusmods.com/assets/images/default/noimage.svg"
                                width="600"
                                height="338"
                                alt=""
                              />
                              <div class="fore_div_mods">
                                <img
                                  class="fore"
                                  onerror="imgError(this,'https://www.nexusmods.com/assets/images/default/noimage.svg')"
                                  loading="lazy"
                                  src="https://staticdelivery.nexusmods.com/mods/6119/images/thumbnails/2953/2953-1740134491-566554994.jpeg"
                                  alt="Valkyrie Eagle-1 Audio Replacement"
                                  title="Valkyrie Eagle-1 Audio Replacement"
                                />
                              </div>
                            </figure>
                          </a>

                          <div class="tile-desc motm-tile">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/helldivers2/mods/2953"
                                  >Valkyrie Eagle-1 Audio Replacement</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/helldivers2"
                                    >Helldivers 2</a
                                  >
                                  &raquo;
                                  <a
                                    href="https://www.nexusmods.com/helldivers2/mods/categories/3/"
                                    >Audio</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 10:41">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="realauthor">
                                  <span class="label">Author: </span> AmnesiaBat
                                </div>
                                <div class="author">
                                  <span class="label">Uploader: </span>
                                  <a
                                    href="https://www.nexusmods.com/users/157033883"
                                    >AmnesiaBat</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                Replacement of eagle-1's voicelines
                              </p>
                            </div>
                          </div>

                          <div class="tile-data">
                            <ul class="clearfix">
                              <li class="sizecount inline-flex">
                                <svg title="" class="icon icon-filesize">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-filesize"
                                  ></use>
                                </svg>
                                <span class="flex-label"> 1.0MB </span>
                              </li>
                              <li class="endorsecount inline-flex">
                                <svg title="" class="icon icon-endorse">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-endorse"
                                  ></use>
                                </svg>
                                <span class="flex-label">0</span>
                              </li>
                              <li class="downloadcount inline-flex">
                                <svg title="" class="icon icon-downloads">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-downloads"
                                  ></use>
                                </svg>
                                <span class="flex-label"> -- </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="mod-tile-right">
                          <div class="tile-desc">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/helldivers2/mods/2953"
                                  >Valkyrie Eagle-1 Audio Replacement</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/helldivers2/mods/categories/3/"
                                    >Audio</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 10:41">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="author">
                                  <span class="label">Author: </span
                                  ><a
                                    href="https://www.nexusmods.com/users/157033883"
                                    >AmnesiaBat</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                Replacement of eagle-1's voicelines
                              </p>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="mod-tile">
                        <div id="mod-tile-gallery-1037-2345"></div>

                        <div
                          data-mod-id="2345"
                          data-game-id="1037"
                          class="mod-tile-left"
                        >
                          <div class="expandtile">
                            <div class="btnexpand btnoverlay inline-flex">
                              <div class="padding"></div>
                              <svg title="" class="icon-plus">
                                <use
                                  xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-plus"
                                ></use>
                              </svg>
                              <ul>
                                <li>
                                  <a
                                    class="mod-view"
                                    href="https://www.nexusmods.com/batmanarkhamknight/mods/2345"
                                  >
                                    View mod page
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="mod-gallery"
                                    href="https://www.nexusmods.com/batmanarkhamknight/mods/2345?tab=images"
                                    onclick="get_mod_images(1037,2345, 121345348, )"
                                  >
                                    View image gallery
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <a
                            class="mod-image"
                            href="https://www.nexusmods.com/batmanarkhamknight/mods/2345"
                          >
                            <figure class="image_figure">
                              <img
                                class="back"
                                src="https://www.nexusmods.com/assets/images/default/noimage.svg"
                                width="600"
                                height="338"
                                alt=""
                              />
                              <div class="fore_div_mods">
                                <img
                                  class="fore"
                                  onerror="imgError(this,'https://www.nexusmods.com/assets/images/default/noimage.svg')"
                                  loading="lazy"
                                  src="https://staticdelivery.nexusmods.com/mods/1037/images/thumbnails/2345/2345-1740132927-586794980.png"
                                  alt="Spider-Woman (Gwen Stacy)"
                                  title="Spider-Woman (Gwen Stacy)"
                                />
                              </div>
                            </figure>
                          </a>

                          <div class="tile-desc motm-tile">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/batmanarkhamknight/mods/2345"
                                  >Spider-Woman (Gwen Stacy)</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/batmanarkhamknight"
                                    >Batman: Arkham Knight</a
                                  >
                                  &raquo;
                                  <a
                                    href="https://www.nexusmods.com/batmanarkhamknight/mods/categories/4/"
                                    >Character Skins</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 10:37">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="realauthor">
                                  <span class="label">Author: </span> Lomtvador
                                </div>
                                <div class="author">
                                  <span class="label">Uploader: </span>
                                  <a
                                    href="https://www.nexusmods.com/users/121345348"
                                    >Lomtvador</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                Adds new suit slot for Catwoman.
                              </p>
                            </div>
                          </div>

                          <div class="tile-data">
                            <ul class="clearfix">
                              <li class="sizecount inline-flex">
                                <svg title="" class="icon icon-filesize">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-filesize"
                                  ></use>
                                </svg>
                                <span class="flex-label"> 21.8MB </span>
                              </li>
                              <li class="endorsecount inline-flex">
                                <svg title="" class="icon icon-endorse">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-endorse"
                                  ></use>
                                </svg>
                                <span class="flex-label">0</span>
                              </li>
                              <li class="downloadcount inline-flex">
                                <svg title="" class="icon icon-downloads">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-downloads"
                                  ></use>
                                </svg>
                                <span class="flex-label"> -- </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="mod-tile-right">
                          <div class="tile-desc">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/batmanarkhamknight/mods/2345"
                                  >Spider-Woman (Gwen Stacy)</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/batmanarkhamknight/mods/categories/4/"
                                    >Character Skins</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 10:37">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="author">
                                  <span class="label">Author: </span
                                  ><a
                                    href="https://www.nexusmods.com/users/121345348"
                                    >Lomtvador</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                Adds new suit slot for Catwoman.
                              </p>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="mod-tile">
                        <div id="mod-tile-gallery-100-56050"></div>

                        <div
                          data-mod-id="56050"
                          data-game-id="100"
                          class="mod-tile-left"
                        >
                          <div class="expandtile">
                            <div class="btnexpand btnoverlay inline-flex">
                              <div class="padding"></div>
                              <svg title="" class="icon-plus">
                                <use
                                  xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-plus"
                                ></use>
                              </svg>
                              <ul>
                                <li>
                                  <a
                                    class="mod-view"
                                    href="https://www.nexusmods.com/morrowind/mods/56050"
                                  >
                                    View mod page
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="mod-gallery"
                                    href="https://www.nexusmods.com/morrowind/mods/56050?tab=images"
                                    onclick="get_mod_images(100,56050, 3755459, )"
                                  >
                                    View image gallery
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <a
                            class="mod-image"
                            href="https://www.nexusmods.com/morrowind/mods/56050"
                          >
                            <figure class="image_figure">
                              <img
                                class="back"
                                src="https://www.nexusmods.com/assets/images/default/noimage.svg"
                                width="600"
                                height="338"
                                alt=""
                              />
                              <div class="fore_div_mods">
                                <img
                                  class="fore"
                                  onerror="imgError(this,'https://www.nexusmods.com/assets/images/default/noimage.svg')"
                                  loading="lazy"
                                  src="https://staticdelivery.nexusmods.com/mods/100/images/thumbnails/56050/56050-1740133780-1688971018.png"
                                  alt="SM Sword of a Dead Hero"
                                  title="SM Sword of a Dead Hero"
                                />
                              </div>
                            </figure>
                          </a>

                          <div class="tile-desc motm-tile">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/morrowind/mods/56050"
                                  >SM Sword of a Dead Hero</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a href="https://www.nexusmods.com/morrowind"
                                    >Morrowind</a
                                  >
                                  &raquo;
                                  <a
                                    href="https://www.nexusmods.com/morrowind/mods/categories/31/"
                                    >Weapons</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 10:33">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="realauthor">
                                  <span class="label">Author: </span>
                                  ShadowMimicry
                                </div>
                                <div class="author">
                                  <span class="label">Uploader: </span>
                                  <a
                                    href="https://www.nexusmods.com/users/3755459"
                                    >ShadowMimicry</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                The sword of a dead hero. You know where to get
                                it.... (Dagot UR Lower Facility loc)ID
                                sm_dae_hero
                              </p>
                            </div>
                          </div>

                          <div class="tile-data">
                            <ul class="clearfix">
                              <li class="sizecount inline-flex">
                                <svg title="" class="icon icon-filesize">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-filesize"
                                  ></use>
                                </svg>
                                <span class="flex-label"> 12.9MB </span>
                              </li>
                              <li class="endorsecount inline-flex">
                                <svg title="" class="icon icon-endorse">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-endorse"
                                  ></use>
                                </svg>
                                <span class="flex-label">0</span>
                              </li>
                              <li class="downloadcount inline-flex">
                                <svg title="" class="icon icon-downloads">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-downloads"
                                  ></use>
                                </svg>
                                <span class="flex-label"> -- </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="mod-tile-right">
                          <div class="tile-desc">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/morrowind/mods/56050"
                                  >SM Sword of a Dead Hero</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/morrowind/mods/categories/31/"
                                    >Weapons</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 10:33">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="author">
                                  <span class="label">Author: </span
                                  ><a
                                    href="https://www.nexusmods.com/users/3755459"
                                    >ShadowMimicry</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                The sword of a dead hero. You know where to get
                                it.... (Dagot UR Lower Facility loc)ID
                                sm_dae_hero
                              </p>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="mod-tile">
                        <div id="mod-tile-gallery-952-10456"></div>

                        <div
                          data-mod-id="10456"
                          data-game-id="952"
                          class="mod-tile-left"
                        >
                          <div class="expandtile">
                            <div class="btnexpand btnoverlay inline-flex">
                              <div class="padding"></div>
                              <svg title="" class="icon-plus">
                                <use
                                  xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-plus"
                                ></use>
                              </svg>
                              <ul>
                                <li>
                                  <a
                                    class="mod-view"
                                    href="https://www.nexusmods.com/witcher3/mods/10456"
                                  >
                                    View mod page
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="mod-gallery"
                                    href="https://www.nexusmods.com/witcher3/mods/10456?tab=images"
                                    onclick="get_mod_images(952,10456, 115780493, )"
                                  >
                                    View image gallery
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <a
                            class="mod-image"
                            href="https://www.nexusmods.com/witcher3/mods/10456"
                          >
                            <figure class="image_figure">
                              <img
                                class="back"
                                src="https://www.nexusmods.com/assets/images/default/noimage.svg"
                                width="600"
                                height="338"
                                alt=""
                              />
                              <div class="fore_div_mods">
                                <img
                                  class="fore"
                                  onerror="imgError(this,'https://www.nexusmods.com/assets/images/default/noimage.svg')"
                                  loading="lazy"
                                  src="https://staticdelivery.nexusmods.com/mods/952/images/thumbnails/10456/10456-1739640601-1414286220.png"
                                  alt="Fix Camera Shake"
                                  title="Fix Camera Shake"
                                />
                              </div>
                            </figure>
                          </a>

                          <div class="tile-desc motm-tile">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/witcher3/mods/10456"
                                  >Fix Camera Shake</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a href="https://www.nexusmods.com/witcher3"
                                    >The Witcher 3</a
                                  >
                                  &raquo;
                                  <a
                                    href="https://www.nexusmods.com/witcher3/mods/categories/12/"
                                    >Bug Fixes</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 10:17">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="realauthor">
                                  <span class="label">Author: </span> crthdr
                                </div>
                                <div class="author">
                                  <span class="label">Uploader: </span>
                                  <a
                                    href="https://www.nexusmods.com/users/115780493"
                                    >crthdr</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                Fixes minor bugs related to camera shake
                              </p>
                            </div>
                          </div>

                          <div class="tile-data">
                            <ul class="clearfix">
                              <li class="sizecount inline-flex">
                                <svg title="" class="icon icon-filesize">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-filesize"
                                  ></use>
                                </svg>
                                <span class="flex-label"> 3KB </span>
                              </li>
                              <li class="endorsecount inline-flex">
                                <svg title="" class="icon icon-endorse">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-endorse"
                                  ></use>
                                </svg>
                                <span class="flex-label">0</span>
                              </li>
                              <li class="downloadcount inline-flex">
                                <svg title="" class="icon icon-downloads">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-downloads"
                                  ></use>
                                </svg>
                                <span class="flex-label"> -- </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="mod-tile-right">
                          <div class="tile-desc">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/witcher3/mods/10456"
                                  >Fix Camera Shake</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/witcher3/mods/categories/12/"
                                    >Bug Fixes</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 10:17">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="author">
                                  <span class="label">Author: </span
                                  ><a
                                    href="https://www.nexusmods.com/users/115780493"
                                    >crthdr</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                Fixes minor bugs related to camera shake
                              </p>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="mod-tile">
                        <div id="mod-tile-gallery-1704-142445"></div>

                        <div
                          data-mod-id="142445"
                          data-game-id="1704"
                          class="mod-tile-left"
                        >
                          <div class="expandtile">
                            <div class="btnexpand btnoverlay inline-flex">
                              <div class="padding"></div>
                              <svg title="" class="icon-plus">
                                <use
                                  xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-plus"
                                ></use>
                              </svg>
                              <ul>
                                <li>
                                  <a
                                    class="mod-view"
                                    href="https://www.nexusmods.com/skyrimspecialedition/mods/142445"
                                  >
                                    View mod page
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="mod-gallery"
                                    href="https://www.nexusmods.com/skyrimspecialedition/mods/142445?tab=images"
                                    onclick="get_mod_images(1704,142445, 188636739, )"
                                  >
                                    View image gallery
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <a
                            class="mod-image"
                            href="https://www.nexusmods.com/skyrimspecialedition/mods/142445"
                          >
                            <figure class="image_figure">
                              <img
                                class="back"
                                src="https://www.nexusmods.com/assets/images/default/noimage.svg"
                                width="600"
                                height="338"
                                alt=""
                              />
                              <div class="fore_div_mods">
                                <img
                                  class="fore"
                                  onerror="imgError(this,'https://www.nexusmods.com/assets/images/default/noimage.svg')"
                                  loading="lazy"
                                  src="https://staticdelivery.nexusmods.com/mods/1704/images/thumbnails/142445/142445-1740133108-2101644513.jpeg"
                                  alt="Templar Assassin Armor(French)"
                                  title="Templar Assassin Armor(French)"
                                />
                              </div>
                            </figure>
                          </a>

                          <div class="tile-desc motm-tile">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/skyrimspecialedition/mods/142445"
                                  >Templar Assassin Armor(French)</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/skyrimspecialedition"
                                    >Skyrim Special Edition</a
                                  >
                                  &raquo;
                                  <a
                                    href="https://www.nexusmods.com/skyrimspecialedition/mods/categories/54/"
                                    >Armour</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 10:03">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="realauthor">
                                  <span class="label">Author: </span> FafnyB
                                </div>
                                <div class="author">
                                  <span class="label">Uploader: </span>
                                  <a
                                    href="https://www.nexusmods.com/users/188636739"
                                    >Lolilofol</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                Traduction de Templar Assassin Armor
                                3BA-BHUNP-CBBE-UNP
                              </p>
                            </div>
                          </div>

                          <div class="tile-data">
                            <ul class="clearfix">
                              <li class="sizecount inline-flex">
                                <svg title="" class="icon icon-filesize">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-filesize"
                                  ></use>
                                </svg>
                                <span class="flex-label"> 1KB </span>
                              </li>
                              <li class="endorsecount inline-flex">
                                <svg title="" class="icon icon-endorse">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-endorse"
                                  ></use>
                                </svg>
                                <span class="flex-label">0</span>
                              </li>
                              <li class="downloadcount inline-flex">
                                <svg title="" class="icon icon-downloads">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-downloads"
                                  ></use>
                                </svg>
                                <span class="flex-label"> -- </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="mod-tile-right">
                          <div class="tile-desc">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/skyrimspecialedition/mods/142445"
                                  >Templar Assassin Armor(French)</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/skyrimspecialedition/mods/categories/54/"
                                    >Armour</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 10:03">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="author">
                                  <span class="label">Author: </span
                                  ><a
                                    href="https://www.nexusmods.com/users/188636739"
                                    >Lolilofol</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                Traduction de Templar Assassin Armor
                                3BA-BHUNP-CBBE-UNP
                              </p>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="mod-tile">
                        <div id="mod-tile-gallery-736-1577"></div>

                        <div
                          data-mod-id="1577"
                          data-game-id="736"
                          class="mod-tile-left"
                        >
                          <div class="expandtile">
                            <div class="btnexpand btnoverlay inline-flex">
                              <div class="padding"></div>
                              <svg title="" class="icon-plus">
                                <use
                                  xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-plus"
                                ></use>
                              </svg>
                              <ul>
                                <li>
                                  <a
                                    class="mod-view"
                                    href="https://www.nexusmods.com/kenshi/mods/1577"
                                  >
                                    View mod page
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="mod-gallery"
                                    href="https://www.nexusmods.com/kenshi/mods/1577?tab=images"
                                    onclick="get_mod_images(736,1577, 92264248, )"
                                  >
                                    View image gallery
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <a
                            class="mod-image"
                            href="https://www.nexusmods.com/kenshi/mods/1577"
                          >
                            <figure class="image_figure">
                              <img
                                class="back"
                                src="https://www.nexusmods.com/assets/images/default/noimage.svg"
                                width="600"
                                height="338"
                                alt=""
                              />
                              <div class="fore_div_mods">
                                <img
                                  class="fore"
                                  onerror="imgError(this,'https://www.nexusmods.com/assets/images/default/noimage.svg')"
                                  loading="lazy"
                                  src="https://staticdelivery.nexusmods.com/mods/736/images/thumbnails/1577/1577-1740131312-1276938557.jpeg"
                                  alt="Start As Beep"
                                  title="Start As Beep"
                                />
                              </div>
                            </figure>
                          </a>

                          <div class="tile-desc motm-tile">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/kenshi/mods/1577"
                                  >Start As Beep</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a href="https://www.nexusmods.com/kenshi"
                                    >Kenshi</a
                                  >
                                  &raquo;
                                  <a
                                    href="https://www.nexusmods.com/kenshi/mods/categories/17/"
                                    >Game Starts</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 09:57">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="realauthor">
                                  <span class="label">Author: </span> labmeatr
                                </div>
                                <div class="author">
                                  <span class="label">Uploader: </span>
                                  <a
                                    href="https://www.nexusmods.com/users/92264248"
                                    >LabmeatR</a
                                  >
                                </div>
                              </div>
                              <p class="desc">Beep! Beep.</p>
                            </div>
                          </div>

                          <div class="tile-data">
                            <ul class="clearfix">
                              <li class="sizecount inline-flex">
                                <svg title="" class="icon icon-filesize">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-filesize"
                                  ></use>
                                </svg>
                                <span class="flex-label"> 1KB </span>
                              </li>
                              <li class="endorsecount inline-flex">
                                <svg title="" class="icon icon-endorse">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-endorse"
                                  ></use>
                                </svg>
                                <span class="flex-label">0</span>
                              </li>
                              <li class="downloadcount inline-flex">
                                <svg title="" class="icon icon-downloads">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-downloads"
                                  ></use>
                                </svg>
                                <span class="flex-label"> -- </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="mod-tile-right">
                          <div class="tile-desc">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/kenshi/mods/1577"
                                  >Start As Beep</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/kenshi/mods/categories/17/"
                                    >Game Starts</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 09:57">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="author">
                                  <span class="label">Author: </span
                                  ><a
                                    href="https://www.nexusmods.com/users/92264248"
                                    >LabmeatR</a
                                  >
                                </div>
                              </div>
                              <p class="desc">Beep! Beep.</p>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="mod-tile">
                        <div id="mod-tile-gallery-7124-405"></div>

                        <div
                          data-mod-id="405"
                          data-game-id="7124"
                          class="mod-tile-left"
                        >
                          <div class="expandtile">
                            <div class="btnexpand btnoverlay inline-flex">
                              <div class="padding"></div>
                              <svg title="" class="icon-plus">
                                <use
                                  xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-plus"
                                ></use>
                              </svg>
                              <ul>
                                <li>
                                  <a
                                    class="mod-view"
                                    href="https://www.nexusmods.com/miside/mods/405"
                                  >
                                    View mod page
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="mod-gallery"
                                    href="https://www.nexusmods.com/miside/mods/405?tab=images"
                                    onclick="get_mod_images(7124,405, 237716825, )"
                                  >
                                    View image gallery
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <a
                            class="mod-image"
                            href="https://www.nexusmods.com/miside/mods/405"
                          >
                            <figure class="image_figure">
                              <img
                                class="back"
                                src="https://www.nexusmods.com/assets/images/default/noimage.svg"
                                width="600"
                                height="338"
                                alt=""
                              />
                              <div class="fore_div_mods">
                                <img
                                  class="fore"
                                  onerror="imgError(this,'https://www.nexusmods.com/assets/images/default/noimage.svg')"
                                  loading="lazy"
                                  src="https://staticdelivery.nexusmods.com/mods/7124/images/thumbnails/405/405-1740131691-1713039454.png"
                                  alt="Maid Mita"
                                  title="Maid Mita"
                                />
                              </div>
                            </figure>
                          </a>

                          <div class="tile-desc motm-tile">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/miside/mods/405"
                                  >Maid Mita</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a href="https://www.nexusmods.com/miside"
                                    >MiSide</a
                                  >
                                  &raquo;
                                  <a
                                    href="https://www.nexusmods.com/miside/mods/categories/3/"
                                    >Characters</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 09:56">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="realauthor">
                                  <span class="label">Author: </span> Black
                                  cloth shoes
                                </div>
                                <div class="author">
                                  <span class="label">Uploader: </span>
                                  <a
                                    href="https://www.nexusmods.com/users/237716825"
                                    >lldmxy2005</a
                                  >
                                </div>
                              </div>
                              <p class="desc">Maid Mita&gt;.&lt;</p>
                            </div>
                          </div>

                          <div class="tile-data">
                            <ul class="clearfix">
                              <li class="sizecount inline-flex">
                                <svg title="" class="icon icon-filesize">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-filesize"
                                  ></use>
                                </svg>
                                <span class="flex-label"> 2.1MB </span>
                              </li>
                              <li class="endorsecount inline-flex">
                                <svg title="" class="icon icon-endorse">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-endorse"
                                  ></use>
                                </svg>
                                <span class="flex-label">0</span>
                              </li>
                              <li class="downloadcount inline-flex">
                                <svg title="" class="icon icon-downloads">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-downloads"
                                  ></use>
                                </svg>
                                <span class="flex-label"> -- </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="mod-tile-right">
                          <div class="tile-desc">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/miside/mods/405"
                                  >Maid Mita</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/miside/mods/categories/3/"
                                    >Characters</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 09:56">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="author">
                                  <span class="label">Author: </span
                                  ><a
                                    href="https://www.nexusmods.com/users/237716825"
                                    >lldmxy2005</a
                                  >
                                </div>
                              </div>
                              <p class="desc">Maid Mita&gt;.&lt;</p>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="mod-tile">
                        <div id="mod-tile-gallery-3333-19878"></div>

                        <div
                          data-mod-id="19878"
                          data-game-id="3333"
                          class="mod-tile-left"
                        >
                          <div class="expandtile">
                            <div class="btnexpand btnoverlay inline-flex">
                              <div class="padding"></div>
                              <svg title="" class="icon-plus">
                                <use
                                  xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-plus"
                                ></use>
                              </svg>
                              <ul>
                                <li>
                                  <a
                                    class="mod-view"
                                    href="https://www.nexusmods.com/cyberpunk2077/mods/19878"
                                  >
                                    View mod page
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="mod-gallery"
                                    href="https://www.nexusmods.com/cyberpunk2077/mods/19878?tab=images"
                                    onclick="get_mod_images(3333,19878, 124339213, )"
                                  >
                                    View image gallery
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <a
                            class="mod-image"
                            href="https://www.nexusmods.com/cyberpunk2077/mods/19878"
                          >
                            <figure class="image_figure">
                              <img
                                class="back"
                                src="https://www.nexusmods.com/assets/images/default/noimage.svg"
                                width="600"
                                height="338"
                                alt=""
                              />
                              <div class="fore_div_mods">
                                <img
                                  class="fore"
                                  onerror="imgError(this,'https://www.nexusmods.com/assets/images/default/noimage.svg')"
                                  loading="lazy"
                                  src="https://staticdelivery.nexusmods.com/mods/3333/images/thumbnails/19878/19878-1740130640-1218901603.jpeg"
                                  alt="22.2 FM Alien Stage Radio"
                                  title="22.2 FM Alien Stage Radio"
                                />
                              </div>
                            </figure>
                          </a>

                          <div class="tile-desc motm-tile">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/cyberpunk2077/mods/19878"
                                  >22.2 FM Alien Stage Radio</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/cyberpunk2077"
                                    >Cyberpunk 2077</a
                                  >
                                  &raquo;
                                  <a
                                    href="https://www.nexusmods.com/cyberpunk2077/mods/categories/4/"
                                    >Audio</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 09:52">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="realauthor">
                                  <span class="label">Author: </span> Kuwiho
                                </div>
                                <div class="author">
                                  <span class="label">Uploader: </span>
                                  <a
                                    href="https://www.nexusmods.com/users/124339213"
                                    >kuwiho</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                Alien Stage has it's own radio in 2077! Adds
                                VIVINOS' Alien Stage Album as a custom radio
                                station.
                              </p>
                            </div>
                          </div>

                          <div class="tile-data">
                            <ul class="clearfix">
                              <li class="sizecount inline-flex">
                                <svg title="" class="icon icon-filesize">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-filesize"
                                  ></use>
                                </svg>
                                <span class="flex-label"> 88.1MB </span>
                              </li>
                              <li class="endorsecount inline-flex">
                                <svg title="" class="icon icon-endorse">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-endorse"
                                  ></use>
                                </svg>
                                <span class="flex-label">0</span>
                              </li>
                              <li class="downloadcount inline-flex">
                                <svg title="" class="icon icon-downloads">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-downloads"
                                  ></use>
                                </svg>
                                <span class="flex-label"> -- </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="mod-tile-right">
                          <div class="tile-desc">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/cyberpunk2077/mods/19878"
                                  >22.2 FM Alien Stage Radio</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/cyberpunk2077/mods/categories/4/"
                                    >Audio</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 09:52">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="author">
                                  <span class="label">Author: </span
                                  ><a
                                    href="https://www.nexusmods.com/users/124339213"
                                    >kuwiho</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                Alien Stage has it's own radio in 2077! Adds
                                VIVINOS' Alien Stage Album as a custom radio
                                station.
                              </p>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="mod-tile">
                        <div id="mod-tile-gallery-2673-11493"></div>

                        <div
                          data-mod-id="11493"
                          data-game-id="2673"
                          class="mod-tile-left"
                        >
                          <div class="expandtile">
                            <div class="btnexpand btnoverlay inline-flex">
                              <div class="padding"></div>
                              <svg title="" class="icon-plus">
                                <use
                                  xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-plus"
                                ></use>
                              </svg>
                              <ul>
                                <li>
                                  <a
                                    class="mod-view"
                                    href="https://www.nexusmods.com/bladeandsorcery/mods/11493"
                                  >
                                    View mod page
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="mod-gallery"
                                    href="https://www.nexusmods.com/bladeandsorcery/mods/11493?tab=images"
                                    onclick="get_mod_images(2673,11493, 167607588, )"
                                  >
                                    View image gallery
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <a
                            class="mod-image"
                            href="https://www.nexusmods.com/bladeandsorcery/mods/11493"
                          >
                            <figure class="image_figure">
                              <img
                                class="back"
                                src="https://www.nexusmods.com/assets/images/default/noimage.svg"
                                width="600"
                                height="338"
                                alt=""
                              />
                              <div class="fore_div_mods">
                                <img
                                  class="fore"
                                  onerror="imgError(this,'https://www.nexusmods.com/assets/images/default/noimage.svg')"
                                  loading="lazy"
                                  src="https://staticdelivery.nexusmods.com/mods/2673/images/thumbnails/11493/11493-1740130836-737855006.jpeg"
                                  alt="Damnation (1.0)"
                                  title="Damnation (1.0)"
                                />
                              </div>
                            </figure>
                          </a>

                          <div class="tile-desc motm-tile">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/bladeandsorcery/mods/11493"
                                  >Damnation (1.0)</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/bladeandsorcery"
                                    >Blade & Sorcery</a
                                  >
                                  &raquo;
                                  <a
                                    href="https://www.nexusmods.com/bladeandsorcery/mods/categories/8/"
                                    >Weapons</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 09:52">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="realauthor">
                                  <span class="label">Author: </span> TechTrees
                                </div>
                                <div class="author">
                                  <span class="label">Uploader: </span>
                                  <a
                                    href="https://www.nexusmods.com/users/167607588"
                                    >TechnicalTrees</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                Adds the Greatsword of Damnation from Elden
                                Ring: Shadow of the Erdtree DLC.
                              </p>
                            </div>
                          </div>

                          <div class="tile-data">
                            <ul class="clearfix">
                              <li class="sizecount inline-flex">
                                <svg title="" class="icon icon-filesize">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-filesize"
                                  ></use>
                                </svg>
                                <span class="flex-label"> 9.6MB </span>
                              </li>
                              <li class="endorsecount inline-flex">
                                <svg title="" class="icon icon-endorse">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-endorse"
                                  ></use>
                                </svg>
                                <span class="flex-label">0</span>
                              </li>
                              <li class="downloadcount inline-flex">
                                <svg title="" class="icon icon-downloads">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-downloads"
                                  ></use>
                                </svg>
                                <span class="flex-label"> -- </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="mod-tile-right">
                          <div class="tile-desc">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/bladeandsorcery/mods/11493"
                                  >Damnation (1.0)</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/bladeandsorcery/mods/categories/8/"
                                    >Weapons</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 09:52">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="author">
                                  <span class="label">Author: </span
                                  ><a
                                    href="https://www.nexusmods.com/users/167607588"
                                    >TechnicalTrees</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                Adds the Greatsword of Damnation from Elden
                                Ring: Shadow of the Erdtree DLC.
                              </p>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="mod-tile">
                        <div id="mod-tile-gallery-7237-471"></div>

                        <div
                          data-mod-id="471"
                          data-game-id="7237"
                          class="mod-tile-left"
                        >
                          <div class="expandtile">
                            <div class="btnexpand btnoverlay inline-flex">
                              <div class="padding"></div>
                              <svg title="" class="icon-plus">
                                <use
                                  xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-plus"
                                ></use>
                              </svg>
                              <ul>
                                <li>
                                  <a
                                    class="mod-view"
                                    href="https://www.nexusmods.com/finalfantasy7rebirth/mods/471"
                                  >
                                    View mod page
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="mod-gallery"
                                    href="https://www.nexusmods.com/finalfantasy7rebirth/mods/471?tab=images"
                                    onclick="get_mod_images(7237,471, 176667531, )"
                                  >
                                    View image gallery
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <a
                            class="mod-image"
                            href="https://www.nexusmods.com/finalfantasy7rebirth/mods/471"
                          >
                            <figure class="image_figure">
                              <img
                                class="back"
                                src="https://www.nexusmods.com/assets/images/default/noimage.svg"
                                width="600"
                                height="338"
                                alt=""
                              />
                              <div class="fore_div_mods">
                                <img
                                  class="fore"
                                  onerror="imgError(this,'https://www.nexusmods.com/assets/images/default/noimage.svg')"
                                  loading="lazy"
                                  src="https://staticdelivery.nexusmods.com/mods/7237/images/thumbnails/471/471-1740131245-884794234.png"
                                  alt="Barret's All Might Cosplay"
                                  title="Barret's All Might Cosplay"
                                />
                              </div>
                            </figure>
                          </a>

                          <div class="tile-desc motm-tile">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/finalfantasy7rebirth/mods/471"
                                  >Barret's All Might Cosplay</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/finalfantasy7rebirth"
                                    >Final Fantasy VII Rebirth</a
                                  >
                                  &raquo;
                                  <a
                                    href="https://www.nexusmods.com/finalfantasy7rebirth/mods/categories/2/"
                                    >Miscellaneous</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 09:50">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="realauthor">
                                  <span class="label">Author: </span>
                                  SoTotallySora
                                </div>
                                <div class="author">
                                  <span class="label">Uploader: </span>
                                  <a
                                    href="https://www.nexusmods.com/users/176667531"
                                    >SoTotallySora</a
                                  >
                                </div>
                              </div>
                              <p class="desc">IIIIIIII AM HEREEEEEEE!</p>
                            </div>
                          </div>

                          <div class="tile-data">
                            <ul class="clearfix">
                              <li class="sizecount inline-flex">
                                <svg title="" class="icon icon-filesize">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-filesize"
                                  ></use>
                                </svg>
                                <span class="flex-label"> 12.1MB </span>
                              </li>
                              <li class="endorsecount inline-flex">
                                <svg title="" class="icon icon-endorse">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-endorse"
                                  ></use>
                                </svg>
                                <span class="flex-label">0</span>
                              </li>
                              <li class="downloadcount inline-flex">
                                <svg title="" class="icon icon-downloads">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-downloads"
                                  ></use>
                                </svg>
                                <span class="flex-label"> -- </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="mod-tile-right">
                          <div class="tile-desc">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/finalfantasy7rebirth/mods/471"
                                  >Barret's All Might Cosplay</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/finalfantasy7rebirth/mods/categories/2/"
                                    >Miscellaneous</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 09:50">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="author">
                                  <span class="label">Author: </span
                                  ><a
                                    href="https://www.nexusmods.com/users/176667531"
                                    >SoTotallySora</a
                                  >
                                </div>
                              </div>
                              <p class="desc">IIIIIIII AM HEREEEEEEE!</p>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="mod-tile">
                        <div id="mod-tile-gallery-1303-31810"></div>

                        <div
                          data-mod-id="31810"
                          data-game-id="1303"
                          class="mod-tile-left"
                        >
                          <div class="expandtile">
                            <div class="btnexpand btnoverlay inline-flex">
                              <div class="padding"></div>
                              <svg title="" class="icon-plus">
                                <use
                                  xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-plus"
                                ></use>
                              </svg>
                              <ul>
                                <li>
                                  <a
                                    class="mod-view"
                                    href="https://www.nexusmods.com/stardewvalley/mods/31810"
                                  >
                                    View mod page
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="mod-gallery"
                                    href="https://www.nexusmods.com/stardewvalley/mods/31810?tab=images"
                                    onclick="get_mod_images(1303,31810, 140234623, )"
                                  >
                                    View image gallery
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <a
                            class="mod-image"
                            href="https://www.nexusmods.com/stardewvalley/mods/31810"
                          >
                            <figure class="image_figure">
                              <img
                                class="back"
                                src="https://www.nexusmods.com/assets/images/default/noimage.svg"
                                width="600"
                                height="338"
                                alt=""
                              />
                              <div class="fore_div_mods">
                                <img
                                  class="fore"
                                  onerror="imgError(this,'https://www.nexusmods.com/assets/images/default/noimage.svg')"
                                  loading="lazy"
                                  src="https://staticdelivery.nexusmods.com/mods/1303/images/thumbnails/31810/31810-1740130905-523697129.jpeg"
                                  alt="Meet Niki - A Stardew Valley Tribune Journalist (Custom NPC) (Turkish)"
                                  title="Meet Niki - A Stardew Valley Tribune Journalist (Custom NPC) (Turkish)"
                                />
                              </div>
                            </figure>
                          </a>

                          <div class="tile-desc motm-tile">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/stardewvalley/mods/31810"
                                  >Meet Niki - A Stardew Valley Tribune
                                  Journalist (Custom NPC) (Turkish)</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/stardewvalley"
                                    >Stardew Valley</a
                                  >
                                  &raquo;
                                  <a
                                    href="https://www.nexusmods.com/stardewvalley/mods/categories/5/"
                                    >Characters</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 09:48">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="realauthor">
                                  <span class="label">Author: </span> Kyojiinnn
                                </div>
                                <div class="author">
                                  <span class="label">Uploader: </span>
                                  <a
                                    href="https://www.nexusmods.com/users/140234623"
                                    >Kyojiinnn</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                Meet Niki - A Stardew Valley Tribune Journalist
                                (Custom NPC) modunun türkçe çevirisidir. Orjinal
                                mod, çevirinin sürümü ile aynı değilse bu
                                çeviriyi kullanmayınız.
                              </p>
                            </div>
                          </div>

                          <div class="tile-data">
                            <ul class="clearfix">
                              <li class="sizecount inline-flex">
                                <svg title="" class="icon icon-filesize">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-filesize"
                                  ></use>
                                </svg>
                                <span class="flex-label"> 28KB </span>
                              </li>
                              <li class="endorsecount inline-flex">
                                <svg title="" class="icon icon-endorse">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-endorse"
                                  ></use>
                                </svg>
                                <span class="flex-label">0</span>
                              </li>
                              <li class="downloadcount inline-flex">
                                <svg title="" class="icon icon-downloads">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-downloads"
                                  ></use>
                                </svg>
                                <span class="flex-label"> -- </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="mod-tile-right">
                          <div class="tile-desc">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/stardewvalley/mods/31810"
                                  >Meet Niki - A Stardew Valley Tribune
                                  Journalist (Custom NPC) (Turkish)</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/stardewvalley/mods/categories/5/"
                                    >Characters</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 09:48">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="author">
                                  <span class="label">Author: </span
                                  ><a
                                    href="https://www.nexusmods.com/users/140234623"
                                    >Kyojiinnn</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                Meet Niki - A Stardew Valley Tribune Journalist
                                (Custom NPC) modunun türkçe çevirisidir. Orjinal
                                mod, çevirinin sürümü ile aynı değilse bu
                                çeviriyi kullanmayınız.
                              </p>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="mod-tile">
                        <div id="mod-tile-gallery-1704-142443"></div>

                        <div
                          data-mod-id="142443"
                          data-game-id="1704"
                          class="mod-tile-left"
                        >
                          <div class="expandtile">
                            <div class="btnexpand btnoverlay inline-flex">
                              <div class="padding"></div>
                              <svg title="" class="icon-plus">
                                <use
                                  xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-plus"
                                ></use>
                              </svg>
                              <ul>
                                <li>
                                  <a
                                    class="mod-view"
                                    href="https://www.nexusmods.com/skyrimspecialedition/mods/142443"
                                  >
                                    View mod page
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="mod-gallery"
                                    href="https://www.nexusmods.com/skyrimspecialedition/mods/142443?tab=images"
                                    onclick="get_mod_images(1704,142443, 99993103, )"
                                  >
                                    View image gallery
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <a
                            class="mod-image"
                            href="https://www.nexusmods.com/skyrimspecialedition/mods/142443"
                          >
                            <figure class="image_figure">
                              <img
                                class="back"
                                src="https://www.nexusmods.com/assets/images/default/noimage.svg"
                                width="600"
                                height="338"
                                alt=""
                              />
                              <div class="fore_div_mods">
                                <img
                                  class="fore"
                                  onerror="imgError(this,'https://www.nexusmods.com/assets/images/default/noimage.svg')"
                                  loading="lazy"
                                  src="https://staticdelivery.nexusmods.com/mods/1704/images/thumbnails/142443/142443-1740131070-308723369.png"
                                  alt="Tower Asada"
                                  title="Tower Asada"
                                />
                              </div>
                            </figure>
                          </a>

                          <div class="tile-desc motm-tile">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/skyrimspecialedition/mods/142443"
                                  >Tower Asada</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/skyrimspecialedition"
                                    >Skyrim Special Edition</a
                                  >
                                  &raquo;
                                  <a
                                    href="https://www.nexusmods.com/skyrimspecialedition/mods/categories/67/"
                                    >Player homes</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 09:48">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="realauthor">
                                  <span class="label">Author: </span> Honorary
                                  Alfanzo
                                </div>
                                <div class="author">
                                  <span class="label">Uploader: </span>
                                  <a
                                    href="https://www.nexusmods.com/users/99993103"
                                    >HalfACupkake</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                Tower Asada is an Imperial Playerhome built into
                                an old imperial fort.
                              </p>
                            </div>
                          </div>

                          <div class="tile-data">
                            <ul class="clearfix">
                              <li class="sizecount inline-flex">
                                <svg title="" class="icon icon-filesize">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-filesize"
                                  ></use>
                                </svg>
                                <span class="flex-label"> 0KB </span>
                              </li>
                              <li class="endorsecount inline-flex">
                                <svg title="" class="icon icon-endorse">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-endorse"
                                  ></use>
                                </svg>
                                <span class="flex-label">0</span>
                              </li>
                              <li class="downloadcount inline-flex">
                                <svg title="" class="icon icon-downloads">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-downloads"
                                  ></use>
                                </svg>
                                <span class="flex-label"> -- </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="mod-tile-right">
                          <div class="tile-desc">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/skyrimspecialedition/mods/142443"
                                  >Tower Asada</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/skyrimspecialedition/mods/categories/67/"
                                    >Player homes</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 09:48">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="author">
                                  <span class="label">Author: </span
                                  ><a
                                    href="https://www.nexusmods.com/users/99993103"
                                    >HalfACupkake</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                Tower Asada is an Imperial Playerhome built into
                                an old imperial fort.
                              </p>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="mod-tile">
                        <div id="mod-tile-gallery-4968-48"></div>

                        <div
                          data-mod-id="48"
                          data-game-id="4968"
                          class="mod-tile-left"
                        >
                          <div class="expandtile">
                            <div class="btnexpand btnoverlay inline-flex">
                              <div class="padding"></div>
                              <svg title="" class="icon-plus">
                                <use
                                  xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-plus"
                                ></use>
                              </svg>
                              <ul>
                                <li>
                                  <a
                                    class="mod-view"
                                    href="https://www.nexusmods.com/worldwarzaftermath/mods/48"
                                  >
                                    View mod page
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="mod-gallery"
                                    href="https://www.nexusmods.com/worldwarzaftermath/mods/48?tab=images"
                                    onclick="get_mod_images(4968,48, 82405528, )"
                                  >
                                    View image gallery
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <a
                            class="mod-image"
                            href="https://www.nexusmods.com/worldwarzaftermath/mods/48"
                          >
                            <figure class="image_figure">
                              <img
                                class="back"
                                src="https://www.nexusmods.com/assets/images/default/noimage.svg"
                                width="600"
                                height="338"
                                alt=""
                              />
                              <div class="fore_div_mods">
                                <img
                                  class="fore"
                                  onerror="imgError(this,'https://www.nexusmods.com/assets/images/default/noimage.svg')"
                                  loading="lazy"
                                  src="https://staticdelivery.nexusmods.com/mods/4968/images/thumbnails/48/48-1740131032-163152310.jpeg"
                                  alt="absolute_black"
                                  title="absolute_black"
                                />
                              </div>
                            </figure>
                          </a>

                          <div class="tile-desc motm-tile">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/worldwarzaftermath/mods/48"
                                  >absolute_black</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/worldwarzaftermath"
                                    >World War Z: Aftermath</a
                                  >
                                  &raquo;
                                  <a
                                    href="https://www.nexusmods.com/worldwarzaftermath/mods/categories/2/"
                                    >Miscellaneous</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 09:47">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="realauthor">
                                  <span class="label">Author: </span> gauss911
                                </div>
                                <div class="author">
                                  <span class="label">Uploader: </span>
                                  <a
                                    href="https://www.nexusmods.com/users/82405528"
                                    >gauss911</a
                                  >
                                </div>
                              </div>
                              <p class="desc">black skin for Dani girl</p>
                            </div>
                          </div>

                          <div class="tile-data">
                            <ul class="clearfix">
                              <li class="sizecount inline-flex">
                                <svg title="" class="icon icon-filesize">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-filesize"
                                  ></use>
                                </svg>
                                <span class="flex-label"> 0KB </span>
                              </li>
                              <li class="endorsecount inline-flex">
                                <svg title="" class="icon icon-endorse">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-endorse"
                                  ></use>
                                </svg>
                                <span class="flex-label">0</span>
                              </li>
                              <li class="downloadcount inline-flex">
                                <svg title="" class="icon icon-downloads">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-downloads"
                                  ></use>
                                </svg>
                                <span class="flex-label"> -- </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="mod-tile-right">
                          <div class="tile-desc">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/worldwarzaftermath/mods/48"
                                  >absolute_black</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/worldwarzaftermath/mods/categories/2/"
                                    >Miscellaneous</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 09:47">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="author">
                                  <span class="label">Author: </span
                                  ><a
                                    href="https://www.nexusmods.com/users/82405528"
                                    >gauss911</a
                                  >
                                </div>
                              </div>
                              <p class="desc">black skin for Dani girl</p>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="mod-tile">
                        <div id="mod-tile-gallery-7286-812"></div>

                        <div
                          data-mod-id="812"
                          data-game-id="7286"
                          class="mod-tile-left"
                        >
                          <div class="expandtile">
                            <div class="btnexpand btnoverlay inline-flex">
                              <div class="padding"></div>
                              <svg title="" class="icon-plus">
                                <use
                                  xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-plus"
                                ></use>
                              </svg>
                              <ul>
                                <li>
                                  <a
                                    class="mod-view"
                                    href="https://www.nexusmods.com/kingdomcomedeliverance2/mods/812"
                                  >
                                    View mod page
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="mod-gallery"
                                    href="https://www.nexusmods.com/kingdomcomedeliverance2/mods/812?tab=images"
                                    onclick="get_mod_images(7286,812, 182093088, )"
                                  >
                                    View image gallery
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <a
                            class="mod-image"
                            href="https://www.nexusmods.com/kingdomcomedeliverance2/mods/812"
                          >
                            <figure class="image_figure">
                              <img
                                class="back"
                                src="https://www.nexusmods.com/assets/images/default/noimage.svg"
                                width="600"
                                height="338"
                                alt=""
                              />
                              <div class="fore_div_mods">
                                <img
                                  class="fore"
                                  onerror="imgError(this,'https://www.nexusmods.com/assets/images/default/noimage.svg')"
                                  loading="lazy"
                                  src="https://staticdelivery.nexusmods.com/mods/7286/images/thumbnails/812/812-1740129381-1802613247.jpeg"
                                  alt="Realistic Lighting Reshade"
                                  title="Realistic Lighting Reshade"
                                />
                              </div>
                            </figure>
                          </a>

                          <div class="tile-desc motm-tile">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/kingdomcomedeliverance2/mods/812"
                                  >Realistic Lighting Reshade</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/kingdomcomedeliverance2"
                                    >Kingdom Come: Deliverance II</a
                                  >
                                  &raquo;
                                  <a
                                    href="https://www.nexusmods.com/kingdomcomedeliverance2/mods/categories/4/"
                                    >Visuals</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 09:44">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="realauthor">
                                  <span class="label">Author: </span>
                                  geraltofpiss232
                                </div>
                                <div class="author">
                                  <span class="label">Uploader: </span>
                                  <a
                                    href="https://www.nexusmods.com/users/182093088"
                                    >geraltofpiss232</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                A very light reshade, with no performance loss.
                                Aims to 'liven up/brighten up' sunlight, giving
                                the game a more pleasing and realistic look,
                                without crushing darks or making the game too
                                bright at night.
                              </p>
                            </div>
                          </div>

                          <div class="tile-data">
                            <ul class="clearfix">
                              <li class="sizecount inline-flex">
                                <svg title="" class="icon icon-filesize">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-filesize"
                                  ></use>
                                </svg>
                                <span class="flex-label"> 7KB </span>
                              </li>
                              <li class="endorsecount inline-flex">
                                <svg title="" class="icon icon-endorse">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-endorse"
                                  ></use>
                                </svg>
                                <span class="flex-label">0</span>
                              </li>
                              <li class="downloadcount inline-flex">
                                <svg title="" class="icon icon-downloads">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-downloads"
                                  ></use>
                                </svg>
                                <span class="flex-label"> -- </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="mod-tile-right">
                          <div class="tile-desc">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/kingdomcomedeliverance2/mods/812"
                                  >Realistic Lighting Reshade</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/kingdomcomedeliverance2/mods/categories/4/"
                                    >Visuals</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 09:44">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="author">
                                  <span class="label">Author: </span
                                  ><a
                                    href="https://www.nexusmods.com/users/182093088"
                                    >geraltofpiss232</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                A very light reshade, with no performance loss.
                                Aims to 'liven up/brighten up' sunlight, giving
                                the game a more pleasing and realistic look,
                                without crushing darks or making the game too
                                bright at night.
                              </p>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="mod-tile">
                        <div id="mod-tile-gallery-1704-142442"></div>

                        <div
                          data-mod-id="142442"
                          data-game-id="1704"
                          class="mod-tile-left"
                        >
                          <div class="expandtile">
                            <div class="btnexpand btnoverlay inline-flex">
                              <div class="padding"></div>
                              <svg title="" class="icon-plus">
                                <use
                                  xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-plus"
                                ></use>
                              </svg>
                              <ul>
                                <li>
                                  <a
                                    class="mod-view"
                                    href="https://www.nexusmods.com/skyrimspecialedition/mods/142442"
                                  >
                                    View mod page
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="mod-gallery"
                                    href="https://www.nexusmods.com/skyrimspecialedition/mods/142442?tab=images"
                                    onclick="get_mod_images(1704,142442, 188636739, )"
                                  >
                                    View image gallery
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <a
                            class="mod-image"
                            href="https://www.nexusmods.com/skyrimspecialedition/mods/142442"
                          >
                            <figure class="image_figure">
                              <img
                                class="back"
                                src="https://www.nexusmods.com/assets/images/default/noimage.svg"
                                width="600"
                                height="338"
                                alt=""
                              />
                              <div class="fore_div_mods">
                                <img
                                  class="fore"
                                  onerror="imgError(this,'https://www.nexusmods.com/assets/images/default/noimage.svg')"
                                  loading="lazy"
                                  src="https://staticdelivery.nexusmods.com/mods/1704/images/thumbnails/142442/142442-1740130689-335439339.jpeg"
                                  alt="Master Thief Armor (French)"
                                  title="Master Thief Armor (French)"
                                />
                              </div>
                            </figure>
                          </a>

                          <div class="tile-desc motm-tile">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/skyrimspecialedition/mods/142442"
                                  >Master Thief Armor (French)</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/skyrimspecialedition"
                                    >Skyrim Special Edition</a
                                  >
                                  &raquo;
                                  <a
                                    href="https://www.nexusmods.com/skyrimspecialedition/mods/categories/54/"
                                    >Armour</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 09:41">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="realauthor">
                                  <span class="label">Author: </span> FafnyB
                                </div>
                                <div class="author">
                                  <span class="label">Uploader: </span>
                                  <a
                                    href="https://www.nexusmods.com/users/188636739"
                                    >Lolilofol</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                Traduction de Master Thief Armor
                                3BA-BHUNP-UNP-CBBE-HIMBO-Vanilla
                              </p>
                            </div>
                          </div>

                          <div class="tile-data">
                            <ul class="clearfix">
                              <li class="sizecount inline-flex">
                                <svg title="" class="icon icon-filesize">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-filesize"
                                  ></use>
                                </svg>
                                <span class="flex-label"> 2KB </span>
                              </li>
                              <li class="endorsecount inline-flex">
                                <svg title="" class="icon icon-endorse">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-endorse"
                                  ></use>
                                </svg>
                                <span class="flex-label">0</span>
                              </li>
                              <li class="downloadcount inline-flex">
                                <svg title="" class="icon icon-downloads">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-downloads"
                                  ></use>
                                </svg>
                                <span class="flex-label"> -- </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="mod-tile-right">
                          <div class="tile-desc">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/skyrimspecialedition/mods/142442"
                                  >Master Thief Armor (French)</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/skyrimspecialedition/mods/categories/54/"
                                    >Armour</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 09:41">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="author">
                                  <span class="label">Author: </span
                                  ><a
                                    href="https://www.nexusmods.com/users/188636739"
                                    >Lolilofol</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                Traduction de Master Thief Armor
                                3BA-BHUNP-UNP-CBBE-HIMBO-Vanilla
                              </p>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="mod-tile">
                        <div id="mod-tile-gallery-7237-470"></div>

                        <div
                          data-mod-id="470"
                          data-game-id="7237"
                          class="mod-tile-left"
                        >
                          <div class="expandtile">
                            <div class="btnexpand btnoverlay inline-flex">
                              <div class="padding"></div>
                              <svg title="" class="icon-plus">
                                <use
                                  xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-plus"
                                ></use>
                              </svg>
                              <ul>
                                <li>
                                  <a
                                    class="mod-view"
                                    href="https://www.nexusmods.com/finalfantasy7rebirth/mods/470"
                                  >
                                    View mod page
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="mod-gallery"
                                    href="https://www.nexusmods.com/finalfantasy7rebirth/mods/470?tab=images"
                                    onclick="get_mod_images(7237,470, 5015521, )"
                                  >
                                    View image gallery
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <a
                            class="mod-image"
                            href="https://www.nexusmods.com/finalfantasy7rebirth/mods/470"
                          >
                            <figure class="image_figure">
                              <img
                                class="back"
                                src="https://www.nexusmods.com/assets/images/default/noimage.svg"
                                width="600"
                                height="338"
                                alt=""
                              />
                              <div class="fore_div_mods">
                                <img
                                  class="fore"
                                  onerror="imgError(this,'https://www.nexusmods.com/assets/images/default/noimage.svg')"
                                  loading="lazy"
                                  src="https://staticdelivery.nexusmods.com/mods/7237/images/thumbnails/470/470-1740130456-1673707850.png"
                                  alt="Nvidia GTX 1650.1660.1660TI cheapest upgrade and best optimization"
                                  title="Nvidia GTX 1650.1660.1660TI cheapest upgrade and best optimization"
                                />
                              </div>
                            </figure>
                          </a>

                          <div class="tile-desc motm-tile">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/finalfantasy7rebirth/mods/470"
                                  >Nvidia GTX 1650.1660.1660TI cheapest upgrade
                                  and best optimization</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/finalfantasy7rebirth"
                                    >Final Fantasy VII Rebirth</a
                                  >
                                  &raquo;
                                  <a
                                    href="https://www.nexusmods.com/finalfantasy7rebirth/mods/categories/2/"
                                    >Miscellaneous</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 09:39">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="realauthor">
                                  <span class="label">Author: </span> Tikilou
                                </div>
                                <div class="author">
                                  <span class="label">Uploader: </span>
                                  <a
                                    href="https://www.nexusmods.com/users/5015521"
                                    >tikilou</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                Want to have the cheapest upgrade to support
                                this game ? Linux + Proton-GE + Optiscaler +
                                Pyroveil + FSR + FrameGen + Gamescope are the
                                best solution. I'm using it with EXP GDC
                                Cheapest oculink external GPU, and it works with
                                1080P support !Don't need any Engine.ini or UE
                                files config, this is more native and better
                                than this !
                              </p>
                            </div>
                          </div>

                          <div class="tile-data">
                            <ul class="clearfix">
                              <li class="sizecount inline-flex">
                                <svg title="" class="icon icon-filesize">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-filesize"
                                  ></use>
                                </svg>
                                <span class="flex-label"> 0KB </span>
                              </li>
                              <li class="endorsecount inline-flex">
                                <svg title="" class="icon icon-endorse">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-endorse"
                                  ></use>
                                </svg>
                                <span class="flex-label">0</span>
                              </li>
                              <li class="downloadcount inline-flex">
                                <svg title="" class="icon icon-downloads">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-downloads"
                                  ></use>
                                </svg>
                                <span class="flex-label"> -- </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="mod-tile-right">
                          <div class="tile-desc">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/finalfantasy7rebirth/mods/470"
                                  >Nvidia GTX 1650.1660.1660TI cheapest upgrade
                                  and best optimization</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/finalfantasy7rebirth/mods/categories/2/"
                                    >Miscellaneous</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 09:39">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="author">
                                  <span class="label">Author: </span
                                  ><a
                                    href="https://www.nexusmods.com/users/5015521"
                                    >tikilou</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                Want to have the cheapest upgrade to support
                                this game ? Linux + Proton-GE + Optiscaler +
                                Pyroveil + FSR + FrameGen + Gamescope are the
                                best solution. I'm using it with EXP GDC
                                Cheapest oculink external GPU, and it works with
                                1080P support !Don't need any Engine.ini or UE
                                files config, this is more native and better
                                than this !
                              </p>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="mod-tile">
                        <div id="mod-tile-gallery-1704-142437"></div>

                        <div
                          data-mod-id="142437"
                          data-game-id="1704"
                          class="mod-tile-left"
                        >
                          <div class="expandtile">
                            <div class="btnexpand btnoverlay inline-flex">
                              <div class="padding"></div>
                              <svg title="" class="icon-plus">
                                <use
                                  xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-plus"
                                ></use>
                              </svg>
                              <ul>
                                <li>
                                  <a
                                    class="mod-view"
                                    href="https://www.nexusmods.com/skyrimspecialedition/mods/142437"
                                  >
                                    View mod page
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="mod-gallery"
                                    href="https://www.nexusmods.com/skyrimspecialedition/mods/142437?tab=images"
                                    onclick="get_mod_images(1704,142437, 54305182, )"
                                  >
                                    View image gallery
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <a
                            class="mod-image"
                            href="https://www.nexusmods.com/skyrimspecialedition/mods/142437"
                          >
                            <figure class="image_figure">
                              <img
                                class="back"
                                src="https://www.nexusmods.com/assets/images/default/noimage.svg"
                                width="600"
                                height="338"
                                alt=""
                              />
                              <div class="fore_div_mods">
                                <img
                                  class="fore"
                                  onerror="imgError(this,'https://www.nexusmods.com/assets/images/default/noimage.svg')"
                                  loading="lazy"
                                  src="https://staticdelivery.nexusmods.com/mods/1704/images/thumbnails/142437/142437-1740130238-1687405815.png"
                                  alt="Compatible Cure Poison Effect for Apothecary"
                                  title="Compatible Cure Poison Effect for Apothecary"
                                />
                              </div>
                            </figure>
                          </a>

                          <div class="tile-desc motm-tile">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/skyrimspecialedition/mods/142437"
                                  >Compatible Cure Poison Effect for
                                  Apothecary</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/skyrimspecialedition"
                                    >Skyrim Special Edition</a
                                  >
                                  &raquo;
                                  <a
                                    href="https://www.nexusmods.com/skyrimspecialedition/mods/categories/94/"
                                    >Alchemy</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 09:36">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="realauthor">
                                  <span class="label">Author: </span> MrBread
                                </div>
                                <div class="author">
                                  <span class="label">Uploader: </span>
                                  <a
                                    href="https://www.nexusmods.com/users/54305182"
                                    >MrPootisBread</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                A simple mod that (sort of) adds Cure Poison
                                effect to Apothecary Alchemy Overhaul without
                                being a compatibilty nightmare.
                              </p>
                            </div>
                          </div>

                          <div class="tile-data">
                            <ul class="clearfix">
                              <li class="sizecount inline-flex">
                                <svg title="" class="icon icon-filesize">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-filesize"
                                  ></use>
                                </svg>
                                <span class="flex-label"> 3KB </span>
                              </li>
                              <li class="endorsecount inline-flex">
                                <svg title="" class="icon icon-endorse">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-endorse"
                                  ></use>
                                </svg>
                                <span class="flex-label">0</span>
                              </li>
                              <li class="downloadcount inline-flex">
                                <svg title="" class="icon icon-downloads">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-downloads"
                                  ></use>
                                </svg>
                                <span class="flex-label"> -- </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="mod-tile-right">
                          <div class="tile-desc">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/skyrimspecialedition/mods/142437"
                                  >Compatible Cure Poison Effect for
                                  Apothecary</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/skyrimspecialedition/mods/categories/94/"
                                    >Alchemy</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 09:36">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="author">
                                  <span class="label">Author: </span
                                  ><a
                                    href="https://www.nexusmods.com/users/54305182"
                                    >MrPootisBread</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                A simple mod that (sort of) adds Cure Poison
                                effect to Apothecary Alchemy Overhaul without
                                being a compatibilty nightmare.
                              </p>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="mod-tile">
                        <div id="mod-tile-gallery-5982-569"></div>

                        <div
                          data-mod-id="569"
                          data-game-id="5982"
                          class="mod-tile-left"
                        >
                          <div class="expandtile">
                            <div class="btnexpand btnoverlay inline-flex">
                              <div class="padding"></div>
                              <svg title="" class="icon-plus">
                                <use
                                  xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-plus"
                                ></use>
                              </svg>
                              <ul>
                                <li>
                                  <a
                                    class="mod-view"
                                    href="https://www.nexusmods.com/railroader/mods/569"
                                  >
                                    View mod page
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="mod-gallery"
                                    href="https://www.nexusmods.com/railroader/mods/569?tab=images"
                                    onclick="get_mod_images(5982,569, 192350882, )"
                                  >
                                    View image gallery
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <a
                            class="mod-image"
                            href="https://www.nexusmods.com/railroader/mods/569"
                          >
                            <figure class="image_figure">
                              <img
                                class="back"
                                src="https://www.nexusmods.com/assets/images/default/noimage.svg"
                                width="600"
                                height="338"
                                alt=""
                              />
                              <div class="fore_div_mods">
                                <img
                                  class="fore"
                                  onerror="imgError(this,'https://www.nexusmods.com/assets/images/default/noimage.svg')"
                                  loading="lazy"
                                  src="https://staticdelivery.nexusmods.com/mods/5982/images/thumbnails/569/569-1740130101-256148198.png"
                                  alt="Gamearoo's Basic Dynamic Weather"
                                  title="Gamearoo's Basic Dynamic Weather"
                                />
                              </div>
                            </figure>
                          </a>

                          <div class="tile-desc motm-tile">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/railroader/mods/569"
                                  >Gamearoo's Basic Dynamic Weather</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a href="https://www.nexusmods.com/railroader"
                                    >Railroader</a
                                  >
                                  &raquo;
                                  <a
                                    href="https://www.nexusmods.com/railroader/mods/categories/2/"
                                    >Miscellaneous</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 09:30">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="realauthor">
                                  <span class="label">Author: </span> Gamearoo
                                </div>
                                <div class="author">
                                  <span class="label">Uploader: </span>
                                  <a
                                    href="https://www.nexusmods.com/users/192350882"
                                    >GamearooCodes</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                Randomly Changes the weather every X game mins
                                Default 30 mins
                              </p>
                            </div>
                          </div>

                          <div class="tile-data">
                            <ul class="clearfix">
                              <li class="sizecount inline-flex">
                                <svg title="" class="icon icon-filesize">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-filesize"
                                  ></use>
                                </svg>
                                <span class="flex-label"> 1.4MB </span>
                              </li>
                              <li class="endorsecount inline-flex">
                                <svg title="" class="icon icon-endorse">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-endorse"
                                  ></use>
                                </svg>
                                <span class="flex-label">0</span>
                              </li>
                              <li class="downloadcount inline-flex">
                                <svg title="" class="icon icon-downloads">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-downloads"
                                  ></use>
                                </svg>
                                <span class="flex-label"> -- </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="mod-tile-right">
                          <div class="tile-desc">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a
                                  href="https://www.nexusmods.com/railroader/mods/569"
                                  >Gamearoo's Basic Dynamic Weather</a
                                >
                              </p>
                              <div class="meta clearfix">
                                <div class="category">
                                  <a
                                    href="https://www.nexusmods.com/railroader/mods/categories/2/"
                                    >Miscellaneous</a
                                  >
                                </div>
                                <time class="date" datetime="2025-02-21 09:30">
                                  <span class="label">Uploaded: </span> 21 Feb
                                  2025
                                </time>
                                <div class="date">
                                  <span class="label">Last Update:</span> 21 Feb
                                  2025
                                </div>
                                <div class="author">
                                  <span class="label">Author: </span
                                  ><a
                                    href="https://www.nexusmods.com/users/192350882"
                                    >GamearooCodes</a
                                  >
                                </div>
                              </div>
                              <p class="desc">
                                Randomly Changes the weather every X game mins
                                Default 30 mins
                              </p>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="btn-more">
                    <a href="/mods/today/?nav=1&page_size=20&page=2" class="btn"
                      >View More - New today</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </section>
        <div class="clearfix" style="text-align: center; background: #2d2d2d">
          <div class="ads">
            <amp-ad
              width="100vw"
              height="320"
              type="adsense"
              :data-ad-client="clientId"
              :data-ad-slot="clientslotId"
              data-auto-format="rspv"
              data-full-width=""
            >
              <div overflow=""></div>
            </amp-ad>
            <div id="ad-container2" align="center"></div>
          </div>
        </div>
        <div id="rj-back-to-top" title="Back to top">
          <i class="fa fa-chevron-up"></i>
        </div>
      </div>
      <footer id="rj-footer">
        <section id="rj-vortex">
          <div class="content rj-grid-12">
            <div
              class="rj-vortex-icon-wrapper col-md-6-12 col-md-pad-2-12 col-lg-4-12 col-lg-pad-3-12"
            >
              <!-- <img class="rj-vortex-icon icon" alt="Vortex" :src="bottomLogo" /> -->
              <span class="rj-vortex-name">{{ proName }}</span>
              <div class="rj-vortex-description">
                The powerful open-source mod manager from {{ proName }}.
              </div>
            </div>
            <div class="col-md-2-12 col-md-pad-8-12 col-lg-pad-7-12">
              <!-- <form action="/" class="rj-button-form"> -->
              <button class="rj-vortex-button">Learn more</button>
              <!-- </form> -->
            </div>
          </div>
        </section>

        <section id="rj-sitemap">
          <div class="content rj-grid-12">
            <div class="rj-sitemap-category col-sm-3-12 col-md-2-12">
              <h3>
                {{ proName }} <i class="rj-chevron fa fa-chevron-down"></i>
              </h3>

              <ul>
                <li><a href="/">News</a></li>
                <li>
                  <a href="/s">Statistics</a>
                </li>
                <li>
                  <a href="/">Careers</a>
                </li>
                <li><a href="/">About us</a></li>
                <li>
                  <a href="/">Premium features</a>
                </li>
              </ul>
            </div>

            <div
              class="rj-sitemap-category col-sm-pad-3-12 col-sm-3-12 col-md-pad-2-12 col-md-2-12"
            >
              <h3>Discover <i class="rj-chevron fa fa-chevron-down"></i></h3>

              <ul>
                <li><a href="/">All games</a></li>
                <li><a href="/">All mods</a></li>
                <li>
                  <a href="/">New mods</a>
                </li>
                <li>
                  <a href="/">Popular mods</a>
                </li>
                <li>
                  <a href="/">Trending mods</a>
                </li>
                <li>
                  <a href="/">All collections</a>
                </li>
                <li>
                  <a href="/">All images</a>
                </li>
              </ul>
            </div>

            <div
              class="rj-sitemap-category col-sm-pad-6-12 col-sm-3-12 col-md-pad-4-12 col-md-2-12"
            >
              <h3>Support <i class="rj-chevron fa fa-chevron-down"></i></h3>
              <ul>
                <li>
                  <a target="_blank" rel="noreferrer" href="/">Help</a>
                </li>
                <li>
                  <a target="_blank" rel="noreferrer" href="/">Wiki</a>
                </li>
                <li>
                  <a target="_blank" rel="noreferrer" href="/">API reference</a>
                </li>
                <li>
                  <a target="_blank" rel="noreferrer" href="/">Give feedback</a>
                </li>
                <li>
                  <a target="_blank" rel="noreferrer" href="/">Report a bug</a>
                </li>
                <li>
                  <a target="_blank" rel="noreferrer" href="/"
                    >Unban requests</a
                  >
                </li>
                <li>
                  <a target="_blank" rel="noreferrer" href="/">DMCA</a>
                </li>
                <li>
                  <a class="nn-cmp-show" href="#">Manage cookie settings</a>
                </li>
              </ul>
            </div>
            <div
              class="rj-sitemap-category rj-sitemap-category-no-border col-sm-pad-9-12 col-sm-3-12 col-md-pad-6-12 col-md-2-12 col-xl-3-12"
            >
              <h3>Community <i class="rj-chevron fa fa-chevron-down"></i></h3>
              <ul>
                <li>
                  <a target="_blank" rel="noreferrer" href="/">Forums</a>
                </li>
                <li>
                  <a target="_blank" rel="noreferrer" href="/">Discord</a>
                </li>
                <li>
                  <a target="_blank" rel="noreferrer" href="/"
                    >Support authors</a
                  >
                </li>
                <li>
                  <a target="_blank" rel="noreferrer" href="/">Contact us</a>
                </li>
              </ul>
            </div>
            <div
              class="col-sm-pad-3-12 col-sm-6-12 col-md-pad-8-12 col-md-4-12 col-xl-pad-9-12 col-xl-3-12"
            >
              <div class="rj-supporter-wrapper">
                <h3>Support {{ proName }}</h3>
                <ul id="footbtn" class="clearfix">
                  <li>
                    <a href="/" class="rj-standard-button">Go premium</a>
                  </li>
                </ul>
              </div>
              <div class="rj-network-stats">
                <h3>Network Stats</h3>
                <ul id="networkstats" class="rj-grid-12 rj-grid-small-gap">
                  <li class="col-md-6-12 col-lg-4-12">
                    <h4>Members</h4>
                    <div class="stat total_members">59,666,083</div>
                  </li>
                  <li
                    class="col-md-pad-6-12 col-md-6-12 col-lg-pad-4-12 col-lg-4-12"
                  >
                    <h4>Mods</h4>
                    <div class="stat total_mods">668,218</div>
                  </li>
                  <li
                    class="row-md-2 col-md-6-12 row-lg-1 col-lg-pad-8-12 col-lg-4-12"
                  >
                    <h4>Kudos given</h4>
                    <div class="stat total_kudos">3,062,501</div>
                  </li>
                  <li class="row-md-3 col-md-6-12 col-lg-12-12">
                    <h4>Page served in</h4>
                    <div class="stat served_time">
                      0.027s [nexusmods-645fbd9cb4-2hkxb]
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section id="rj-logo-social">
          <div class="content rj-grid-12">
            <div class="rj-logo-wrapper col-xs-1-12 col-sm-6-12">
              <!-- <a class="headlogo" href="/" :title="proName">
                <img :src="topLogo" />
              </a> -->
            </div>
            <div
              class="rj-social-wrapper col-xs-1-12 col-sm-6-12 col-sm-pad-6-12"
            >
              <!-- 右下角其他途径logo -->
              <!-- <div class="rj-social-links">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://discord.gg/nexusmods"
                  title="Join us on Discord"
                >
                  <img
                    class="icon"
                    alt="Discord"
                    src="/assets/images/footer/Discord.svg"
                  />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://twitter.com/nexussites"
                  title="Follow us on Twitter"
                >
                  <img
                    class="icon"
                    alt="Twitter"
                    src="/assets/images/footer/Twitter.svg"
                  />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.tiktok.com/@nexusmodsofficial"
                  title="Follow us on TikTok"
                >
                  <img
                    class="icon"
                    alt="TikTok"
                    src="/assets/images/footer/TikTok.svg"
                  />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.twitch.tv/nexusmodsofficial"
                  title="Follow us on Twitch"
                >
                  <img
                    class="icon"
                    alt="Twitch"
                    src="/assets/images/footer/Twitch.svg"
                  />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.youtube.com/@NexusModsOfficial"
                  title="Follow us on Youtube"
                >
                  <img
                    class="icon"
                    alt="Youtube"
                    src="/assets/images/footer/Youtube.svg"
                  />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.instagram.com/nexusmodsofficial"
                  title="Follow us on Instagram"
                >
                  <img
                    class="icon"
                    alt="Instagram"
                    src="/assets/images/footer/Instagram.svg"
                  />
                </a>
              </div> -->
            </div>
          </div>
        </section>
        <section id="rj-foot">
          <div class="content">
            <span class="rj-copyright"
              >Copyright &copy; 2025 Black Tree Gaming Ltd. All rights
              reserved.</span
            >
            <div class="rj-foot-links">
              <a target="_blank" rel="noreferrer" href="/">Terms of Service</a>
              |
              <a target="_blank" rel="noreferrer" href="/">Privacy Policy</a>
            </div>
          </div>
        </section>
      </footer>
      <div id="nn_mobile_lb1"></div>
      <div id="nn_lb2"></div>
    </body>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();
// 菜单列表
const meunList = [
  {
    name: "Games",
    skipUrl: "/",
  },
  {
    name: "Mods",
    skipUrl: "/",
  },
  {
    name: "Collections",
    skipUrl: "/",
  },
  {
    name: "Media",
    skipUrl: "/",
  },
  {
    name: "Community",
    skipUrl: "/",
  },
  {
    name: "Support",
    skipUrl: "/",
  },
];
// 游戏列表
const gameList = ref([
  {
    gameName: "Paper Doll Fo",
    aHerf: "1",
    gameImageUrl: require("@/assets/image/gameImg/y1.png"),
    bigFlag: false,
    alt: "Paper Doll For Girls Dress Up",
    score: "8.0bn",
  },
  {
    gameName: "Color Link Challenge",
    aHerf: "2",
    gameImageUrl: require("@/assets/image/gameImg/y2.png"),
    bigFlag: false,
    alt: "Color Link Challenge",
    score: "8.0bn",
  },
  {
    gameName: "Car Jam Color",
    aHerf: "3",
    gameImageUrl: require("@/assets/image/gameImg/y3.png"),
    bigFlag: true,
    alt: "Car Jam Color",
    score: "8.0bn",
  },
  {
    gameName: "Happy Glass",
    aHerf: "4",
    gameImageUrl: require("@/assets/image/gameImg/y4.png"),
    bigFlag: false,
    alt: "Happy Glass",
    score: "8.0bn",
  },
  {
    gameName: "Slide Blocks",
    aHerf: "5",
    gameImageUrl: require("@/assets/image/gameImg/y5.png"),
    bigFlag: false,
    alt: "Slide Blocks Puzzle",
    score: "7.8bn",
  },
  {
    gameName: "Cannon Balls",
    aHerf: "6",
    gameImageUrl: require("@/assets/image/gameImg/y6.png"),
    bigFlag: false,
    alt: "Cannon Balls - Arcade",
    score: "7.8bn",
  },
  {
    gameName: "Basketball Sw",
    aHerf: "7",
    gameImageUrl: require("@/assets/image/gameImg/y7.png"),
    bigFlag: false,
    alt: "Basketball Swooshes",
    score: "7.8bn",
  },
  {
    gameName: "Build Tower",
    aHerf: "8",
    gameImageUrl: require("@/assets/image/gameImg/y8.png"),
    bigFlag: false,
    alt: "Build Tower",
    score: "7.8bn",
  },
  {
    gameName: "Mushroom Pop",
    aHerf: "9",
    gameImageUrl: require("@/assets/image/gameImg/y9.png"),
    bigFlag: false,
    alt: "Mushroom Pop",
    score: "7.8bn",
  },
  {
    gameName: "Jumper Bot",
    aHerf: "10",
    gameImageUrl: require("@/assets/image/gameImg/y10.png"),
    bigFlag: false,
    alt: "Jumper Bot",
    score: "7.8bn",
  },
  {
    gameName: "Ghost Float",
    aHerf: "11",
    gameImageUrl: require("@/assets/image/gameImg/y11.png"),
    bigFlag: false,
    alt: "Ghost Float",
    score: "7.6bn",
  },
  {
    gameName: "Flamingo Bing",
    aHerf: "12",
    gameImageUrl: require("@/assets/image/gameImg/y12.png"),
    bigFlag: false,
    alt: "Flamingo Bingo",
    score: "7.6bn",
  },
  {
    gameName: "Zombie Wipeou",
    aHerf: "13",
    gameImageUrl: require("@/assets/image/gameImg/y13.png"),
    bigFlag: false,
    alt: "Zombie Wipeout",
    score: "7.6bn",
  },
  {
    gameName: "Dd Pixel Slid",
    aHerf: "14",
    gameImageUrl: require("@/assets/image/gameImg/y14.png"),
    bigFlag: true,
    alt: "Dd Pixel Slide",
    score: "7.6bn",
  },
  {
    gameName: "Swipe The Pin",
    aHerf: "15",
    gameImageUrl: require("@/assets/image/gameImg/y15.png"),
    bigFlag: false,
    alt: "Swipe The Pin",
    score: "7.6bn",
  },
  {
    gameName: "Oomee Piñata",
    aHerf: "16",
    gameImageUrl: require("@/assets/image/gameImg/y16.png"),
    bigFlag: false,
    alt: "Oomee Piñata",
    score: "7.6bn",
  },
  {
    gameName: "Changer Jam",
    aHerf: "17",
    gameImageUrl: require("@/assets/image/gameImg/y17.png"),
    bigFlag: false,
    alt: "Changer Jam",
    score: "7.6bn",
  },
  {
    gameName: "Find The Set",
    aHerf: "18",
    gameImageUrl: require("@/assets/image/gameImg/y18.png"),
    bigFlag: false,
    alt: "Find The Set",
    score: "7.6bn",
  },
]);

// 底部游戏列表
const gameBottomList = ref([
  {
    gameName: "Fire And Wate",
    aHerf: "21",
    gameImageUrl: require("@/assets/image/gameImg/y21.png"),
    bigFlag: false,
    alt: "Fire And Water Stickman",
    viewNum: 5555,
    score: "8.0bn",
  },
  {
    gameName: "2048 Champion",
    aHerf: "22",
    gameImageUrl: require("@/assets/image/gameImg/y22.png"),
    bigFlag: true,
    alt: "2048 Champion",
    viewNum: 2137,
    score: "7.8bn",
  },
  {
    gameName: "Clones",
    aHerf: "23",
    gameImageUrl: require("@/assets/image/gameImg/y23.png"),
    bigFlag: false,
    alt: "Clones",
    viewNum: 1555,
    score: "7.6bn",
  },
  {
    gameName: "Firefighter R",
    aHerf: "24",
    gameImageUrl: require("@/assets/image/gameImg/y24.png"),
    bigFlag: false,
    alt: "Firefighter Rescue Quest",
    viewNum: 780,
    score: "7.6bn",
  },
  {
    gameName: "Dragon's Defe",
    aHerf: "25",
    gameImageUrl: require("@/assets/image/gameImg/y25.png"),
    bigFlag: false,
    alt: "Dragon's Defense Reign Of Fire",
    viewNum: 1323,
    score: "5.6bn",
  },
  {
    gameName: "Chin Up Shin",
    aHerf: "26",
    gameImageUrl: require("@/assets/image/gameImg/y26.png"),
    bigFlag: true,
    alt: "Chin Up Shin Up",
    viewNum: 1209,
    score: "6.1bn",
  },
  {
    gameName: "Counter Craft",
    aHerf: "27",
    gameImageUrl: require("@/assets/image/gameImg/y27.png"),
    bigFlag: false,
    alt: "Counter Craft 5",
    viewNum: 879,
    score: "7.2bn",
  },
  {
    gameName: "The Bomb",
    aHerf: "28",
    gameImageUrl: require("@/assets/image/gameImg/y28.png"),
    bigFlag: true,
    alt: "The Bomb",
    viewNum: 860,
    score: "7.7bn",
  },
  {
    gameName: "Princesses At",
    aHerf: "29",
    gameImageUrl: require("@/assets/image/gameImg/y29.png"),
    bigFlag: false,
    alt: "Princesses At Horror School",
    viewNum: 531,
    score: "7.9bn",
  },
  {
    gameName: "Number Match",
    aHerf: "30",
    gameImageUrl: require("@/assets/image/gameImg/y30.png"),
    bigFlag: false,
    alt: "Number Match - Match Ten",
    viewNum: 768,
    score: "7.5bn",
  },
  {
    gameName: "Ultimate Noug",
    aHerf: "31",
    gameImageUrl: require("@/assets/image/gameImg/y31.png"),
    bigFlag: false,
    alt: "Ultimate Noughts &amp; Crosses",
    viewNum: 980,
    score: "7.1bn",
  },
  {
    gameName: "Arrowblob Puz",
    aHerf: "32",
    gameImageUrl: require("@/assets/image/gameImg/y32.png"),
    bigFlag: false,
    alt: "Arrowblob Puzzle Quest",
    viewNum: 988,
    score: "6.2bn",
  },
  {
    gameName: "Ascend",
    aHerf: "33",
    gameImageUrl: require("@/assets/image/gameImg/y33.png"),
    bigFlag: false,
    alt: "Ascend",
    viewNum: 586,
    score: "5.6bn",
  },
  {
    gameName: "Race",
    aHerf: "34",
    gameImageUrl: require("@/assets/image/gameImg/y34.png"),
    bigFlag: false,
    alt: "Race",
    viewNum: 245,
    score: "8.6bn",
  },
  {
    gameName: "Tanks Battle",
    aHerf: "35",
    gameImageUrl: require("@/assets/image/gameImg/y35.png"),
    bigFlag: false,
    alt: "Tanks Battle Field",
    viewNum: 856,
    score: "8.6bn",
  },
  {
    gameName: "Battlegrid On",
    aHerf: "36",
    gameImageUrl: require("@/assets/image/gameImg/y36.png"),
    bigFlag: false,
    alt: "Battlegrid Online Pvp Tank Battles",
    viewNum: 153,
    score: "8.8bn",
  },
  {
    gameName: "Pumpkin Of Go",
    aHerf: "37",
    gameImageUrl: require("@/assets/image/gameImg/y37.png"),
    bigFlag: false,
    alt: "Pumpkin Of Goo",
    viewNum: 122,
    score: "8.6bn",
  },
  {
    gameName: "Apostle's Cre",
    aHerf: "38",
    gameImageUrl: require("@/assets/image/gameImg/y38.png"),
    bigFlag: false,
    alt: "Apostle's Creed I",
    viewNum: 436,
    score: "7.9bn",
  },
  {
    gameName: "Zombie Runner",
    aHerf: "39",
    gameImageUrl: require("@/assets/image/gameImg/y39.png"),
    bigFlag: true,
    alt: "Zombie Runner",
    viewNum: 1152,
    score: "7.8bn",
  },
  {
    gameName: "Fruit Name Ju",
    aHerf: "40",
    gameImageUrl: require("@/assets/image/gameImg/y40.png"),
    bigFlag: false,
    alt: "Fruit Name Jump",
    viewNum: 867,
    score: "7.6bn",
  },
]);
const navigateToGame = (index) => {
  router.push({ name: "play", query: { gameId: index } });
};
const handleClickBottomBtn = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

const proName = process.env.VUE_APP_PROJECTNAME;
/**
 * adsense
 */
const clientId = process.env.VUE_APP_ADSENSEID;
const clientslotId = process.env.VUE_APP_ADSENSESLOTID;

const loadAds = () => {
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${process.env.VUE_APP_ADSENSEID}`;
  script.crossOrigin = "anonymous";

  // 创建并配置 <ins> 元素
  const ins = document.createElement("ins");
  ins.className = "adsbygoogle";
  ins.style.display = "block";

  ins.setAttribute("data-ad-client", process.env.VUE_APP_ADSENSEID);
  ins.setAttribute("data-ad-slot", process.env.VUE_APP_ADSENSESLOTID);
  const adContainer = document.getElementById("ad-container");
  if (adContainer) {
    adContainer.appendChild(script);
    adContainer.appendChild(ins);

    setTimeout(() => {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }, 1000);
  } else {
    console.error("Ad container not found!");
  }
};
const loadAds2 = () => {
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${process.env.VUE_APP_ADSENSEID}`;
  script.crossOrigin = "anonymous";

  const ins = document.createElement("ins");
  ins.className = "adsbygoogle";
  ins.style.display = "block";
  ins.setAttribute("data-ad-client", process.env.VUE_APP_ADSENSEID);
  ins.setAttribute("data-ad-slot", process.env.VUE_APP_ADSENSESLOTID);

  const adContainer = document.getElementById("ad-container2");
  if (adContainer) {
    adContainer.appendChild(script);
    adContainer.appendChild(ins);

    setTimeout(() => {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }, 1000);
  } else {
    console.error("Ad container not found!");
  }
};
const bottomLogo = require("@/assets/image/logo.jpg");
const topLogo = require("@/assets/image/logo-white.png");

onMounted(() => {
  loadAds();
  loadAds2();
});
</script>

<style lang="scss" scoped>
.notification {
  display: flex;
  font-size: 14px;
  color: white;
  width: 100%;
  justify-content: space-between;
}

.notification-link {
  width: 80%;
}

.notification-category-icon-wrapper {
  width: 15%;
}

.notification-category-specific-icon {
  border-radius: 20px;
  object-fit: cover;
  object-position: center;
}

.notification-category-generic-icon,
.notification-category-specific-icon {
  width: 30px;
  height: 30px;
}

.notification-content {
  width: 85%;
}

.notifications-list ul li .notification-bold,
.notifications-list ul li .text-primary,
.notifications-list ul li .text-primary-moderate {
  display: inline;
  font-weight: 600;
  color: var(--rj-orange-font);
}

.notifications-list ul li .notification-content > div:first-child {
  min-height: 40px;
}

.notification-row {
  margin-bottom: 10px;
}

.notification-date {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
}

.notification-icon {
  border-radius: 21px;
  height: 42px;
  width: 42px;
  background-repeat: no-repeat;
  background-size: 42px 42px;
  margin-right: 10px;
}

.notification-indicator-wrapper {
  height: 100%;
  width: 12%;
}

.notification-indicator-box {
  visibility: hidden;
  width: 24px;
  height: 24px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.expanding-hover {
  position: relative;
}

.expanding-hover::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  height: 0;
  width: 0;
  border-radius: 100%;
  background-color: var(--rj-white-30);
  transition-property: height, width, top, left;
  transition-duration: 0.25s;
  transition-timing-function: ease-in-out;
}

.expanding-hover:hover::before {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.notification-wrapper.notification-unread .notification-indicator-box {
  visibility: visible;
}

.notification-indicator {
  border-radius: 4px;
  width: 8px;
  height: 8px;
  margin: auto;
  background: var(--rj-orange-font);
  padding: 0;
  border: 0;
}

.icons-row {
  display: flex;
}

.notification-menu-wrapper {
  width: 8%;
  display: flex;
  height: 24px;
  justify-content: center;
}

.notification-menu-button {
  width: 24px;
  background: none;
  border: 0;
  padding: 0;
}

.notification-menu-hidden {
  display: hidden;
}

.notification-menu {
  background-color: var(--rj-nexusblack-high-contrast);
  display: none;
  font-family: Montserrat;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  z-index: 1;
  opacity: 1;
  border-radius: 4px;
  border: 1px solid #3e413f;
}

.notification-menu-row {
  display: flex;
  height: 48px;
  align-items: center;
  box-sizing: border-box;
  padding: 12px 10px 12px 16px;
  gap: 10px;
}

.notification-menu-row.notification-remove {
  margin-top: 16px;
  position: relative;
}

.notification-menu-row.notification-remove:before {
  content: "";
  background: #3c3f44;
  height: 1px;
  padding: 0;
  position: absolute;
  top: -8px;
  left: 7px;
  right: 7px;
}

.notification-menu-row:hover {
  background-color: var(--rj-white-05);
}

.notification-mark-as-read,
.notification-mark-as-unread {
  display: none;
}

.notification-wrapper.notification-unread .notification-mark-as-read {
  display: flex;
}

.notification-wrapper.notification-read .notification-mark-as-unread {
  display: flex;
}

.notification-menu-icon-wrapper {
  padding: 0;
  margin: 0;
  width: 24px;
}

.notification-menu-icon {
  padding: 0;
  margin: 0;
  width: 24px;
}

.notification-menu-text {
  background: none;
  border: 0;
  text-transform: uppercase;
  padding: 0;
  margin: 0;
  letter-spacing: 1.4px;
  white-space: nowrap;
}

.notification-read .notification {
  opacity: 0.5;
}

@media (min-width: 1024px) {
  .notification-category-generic-icon,
  .notification-category-specific-icon {
    width: 35px;
    height: 35px;
  }
  .notification-wrapper:hover .notification-menu-wrapper,
  .notification-wrapper:focus-within .notification-menu-wrapper {
    visibility: visible;
  }
  .notification-menu-wrapper {
    visibility: hidden;
  }
}

.notification-menu {
  position: absolute;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  top: 47px;
  right: 20px;
}

.collections-banner-outer-wrapper-trigger .collections-banner-wrapper {
  background: #2d2d2d;
  padding: 32px 16px;
}

.collections-banner {
  position: relative;
  width: 100%;
  background: #0555b8;
  color: white;
  height: 68px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 16px;
  font-family: montserrat;
  cursor: pointer;
  gap: 12px;
  font-size: 18px;
  letter-spacing: 0.15px;
}

.collections-banner > span {
  position: relative;
}

.collections-banner:hover {
  color: white;
}

.collections-banner__splash {
  display: none;
  position: absolute;
  right: 4px;
  top: 4px;
  bottom: 4px;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 60px 100%);
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  overflow: hidden;
  width: calc(100% - 600px);
  max-width: 644px;
}

.collections-banner__splash-image {
  height: 100%;
  object-fit: cover;
  object-position: 0%;
}

@media only screen and (min-width: 768px) {
  .collections-banner__splash {
    display: block;
  }
}

.premium-block {
  position: relative;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.premium-block.premium-block--register {
  align-items: center;
}

.premium-block--register .premium-block__link-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.premium-block--register .premium-block__link-wrapper > a {
  margin-bottom: 16px;
}

.premium-block--register .premium-block__link-wrapper > span {
  font-weight: bold;
  color: rgba(255, 255, 255, 0.8);
}

.premium-block--register .premium-block__text-wrapper {
  text-align: center;
}

.premium-block--register .premium-block__text-wrapper h2 {
  width: 100%;
}

.premium-block.background-1 {
  background: linear-gradient(to right, #040404, 70%, transparent),
    url("https://staticdelivery.nexusmods.com/Images/ad_bg_1.png") right/60%
      no-repeat,
    #040404;
}

.premium-block.background-2 {
  background: linear-gradient(to right, #040404, 70%, transparent),
    url("https://staticdelivery.nexusmods.com/Images/ad_bg_2.png") right/60%
      no-repeat,
    #040404;
}

.premium-block.hidden {
  display: none;
}

.premium-block::before {
  top: 0;
}

.premium-block::after {
  bottom: 0;
}

.premium-block__text-wrapper {
  text-align: left;
  width: 100%;
  margin-bottom: 16px;
}

.premium-block__link-wrapper {
  text-align: left;
}

.premium-block__text-wrapper h2 {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  font-weight: bold;
  font-size: 24px;
  width: 80%;
}

.premium-block__text-wrapper p {
  font-weight: 400;
  color: rgba(225, 225, 225, 0.8);
}

.premium-block__link-wrapper > a.rj-btn {
  width: 200px;
}

.premium-block--register .premium-block__link-wrapper > a.rj-btn {
  width: 100%;
}

.premium-block__link-wrapper > a.rj-btn i:last-child {
  margin-left: 8px;
}

@media (min-width: 768px) {
  .premium-block {
    padding: 32px 16px;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }
  .premium-block__text-wrapper {
    width: 70%;
    margin-bottom: 0;
  }
  .premium-block--register .premium-block__text-wrapper {
    width: 50%;
    text-align: left;
  }
  .premium-block--register .premium-block__link-wrapper > a.rj-btn {
    width: 200px;
  }
}

@media (min-width: 1000px) {
  .premium-block__text-wrapper {
    text-align: center;
  }
  .premium-block--register .premium-block__text-wrapper {
    width: 50%;
    text-align: center;
  }
  .premium-block__link-wrapper {
    text-align: center;
  }
  .premium-block__text-wrapper h2 {
    font-size: 32px;
    width: 100%;
  }
  .premium-block__text-wrapper br {
    display: none;
  }
}
</style>
